// AUTO-GENERATED by scripts/gen-data.mjs from mechanics/*.md — DO NOT EDIT.
// Regenerate: node scripts/gen-data.mjs   Verify: node scripts/gen-data.mjs --check
// Data fix-ups applied during generation are documented in src/engine/data/README.md.

export interface PickRow { id: string; cost: number; value: number | null; meaning: string }
export interface BuildableRow { id: string; techId: number; cost: number; maintenance: number; group: string }
export interface FieldRow { id: string; num: number; previous: number; next: number; cost: number; tier: number; general: boolean }
export interface TechRow { id: string; techId: number; fieldNum: number; aiGroup: number; strategic: boolean }
export interface HullRow {
  id: string; cost: number; space: number; marines: number;
  armorHp: number; structureHp: number; computerHp: number; driveHp: number; shieldHp: number;
  strategic: { beam: number; missile: number; special: number; bomb: number; defBonus: number; hits: number };
}
export interface WeaponRow {
  id: string; techId: number; classId: number; ammo: number; space: number; cost: number;
  naturalMods: string[]; tacticalDamage: { min: number; max: number };
  strategicDamage: { min: number; max: number }; availableMods: string[];
}
export interface WeaponModRow {
  id: string; modId: number; miniaturizationLevel: number;
  spacePercent: number; costPercent: number; damageMultiplier: number; hint: string;
}
export interface ApplicationRow {
  id: string; name: string; subject: string; fieldId: string; techId: number | null;
  /** what the technology does, from mechanics/tech/technology_effects.md */
  effectSummary: string;
  effectSummaryLen: number;
}

export const PICK_ROWS: readonly PickRow[] = [
  {
    "id": "growth1",
    "cost": -4,
    "value": -50,
    "meaning": "Population growth penalty tier."
  },
  {
    "id": "growth2",
    "cost": 3,
    "value": 50,
    "meaning": "Population growth bonus tier."
  },
  {
    "id": "growth3",
    "cost": 6,
    "value": 100,
    "meaning": "Higher population growth bonus tier."
  },
  {
    "id": "farming1",
    "cost": -3,
    "value": -1,
    "meaning": "Farming output penalty."
  },
  {
    "id": "farming2",
    "cost": 4,
    "value": 2,
    "meaning": "Farming output bonus."
  },
  {
    "id": "farming3",
    "cost": 7,
    "value": 4,
    "meaning": "Higher farming output bonus."
  },
  {
    "id": "industry1",
    "cost": -3,
    "value": -1,
    "meaning": "Industry output penalty."
  },
  {
    "id": "industry2",
    "cost": 3,
    "value": 1,
    "meaning": "Industry output bonus."
  },
  {
    "id": "industry3",
    "cost": 6,
    "value": 2,
    "meaning": "Higher industry output bonus."
  },
  {
    "id": "science1",
    "cost": -3,
    "value": -1,
    "meaning": "Research output penalty."
  },
  {
    "id": "science2",
    "cost": 3,
    "value": 1,
    "meaning": "Research output bonus."
  },
  {
    "id": "science3",
    "cost": 6,
    "value": 2,
    "meaning": "Higher research output bonus."
  },
  {
    "id": "money1",
    "cost": -4,
    "value": -1,
    "meaning": "BC/income penalty."
  },
  {
    "id": "money2",
    "cost": 5,
    "value": 1,
    "meaning": "BC/income bonus."
  },
  {
    "id": "money3",
    "cost": 8,
    "value": 2,
    "meaning": "Higher BC/income bonus."
  },
  {
    "id": "defense1",
    "cost": -2,
    "value": -20,
    "meaning": "Ship defense penalty."
  },
  {
    "id": "defense2",
    "cost": 3,
    "value": 25,
    "meaning": "Ship defense bonus."
  },
  {
    "id": "defense3",
    "cost": 7,
    "value": 50,
    "meaning": "Higher ship defense bonus."
  },
  {
    "id": "attack1",
    "cost": -2,
    "value": -20,
    "meaning": "Ship attack penalty."
  },
  {
    "id": "attack2",
    "cost": 2,
    "value": 20,
    "meaning": "Ship attack bonus."
  },
  {
    "id": "attack3",
    "cost": 4,
    "value": 50,
    "meaning": "Higher ship attack bonus."
  },
  {
    "id": "ground1",
    "cost": -2,
    "value": -10,
    "meaning": "Ground combat penalty."
  },
  {
    "id": "ground2",
    "cost": 2,
    "value": 10,
    "meaning": "Ground combat bonus."
  },
  {
    "id": "ground3",
    "cost": 4,
    "value": 20,
    "meaning": "Higher ground combat bonus."
  },
  {
    "id": "spying1",
    "cost": -3,
    "value": -10,
    "meaning": "Spying penalty."
  },
  {
    "id": "spying2",
    "cost": 3,
    "value": 10,
    "meaning": "Spying bonus."
  },
  {
    "id": "spying3",
    "cost": 6,
    "value": 20,
    "meaning": "Higher spying bonus."
  },
  {
    "id": "feudal",
    "cost": -4,
    "value": null,
    "meaning": "Government: Feudal."
  },
  {
    "id": "dictatorship",
    "cost": 0,
    "value": null,
    "meaning": "Government: Dictatorship."
  },
  {
    "id": "democracy",
    "cost": 7,
    "value": null,
    "meaning": "Government: Democracy."
  },
  {
    "id": "unification",
    "cost": 6,
    "value": null,
    "meaning": "Government: Unification."
  },
  {
    "id": "lowg_world",
    "cost": -5,
    "value": null,
    "meaning": "Homeworld gravity trait: low-G."
  },
  {
    "id": "highg_world",
    "cost": 6,
    "value": null,
    "meaning": "Homeworld gravity trait: high-G."
  },
  {
    "id": "aquatic",
    "cost": 5,
    "value": null,
    "meaning": "Aquatic habitability/population trait."
  },
  {
    "id": "subterranean",
    "cost": 6,
    "value": null,
    "meaning": "Increased planet population capacity."
  },
  {
    "id": "large_hw",
    "cost": 1,
    "value": null,
    "meaning": "Larger homeworld."
  },
  {
    "id": "rich_hw",
    "cost": 2,
    "value": null,
    "meaning": "Richer homeworld minerals."
  },
  {
    "id": "poor_hw",
    "cost": -1,
    "value": null,
    "meaning": "Poor homeworld minerals."
  },
  {
    "id": "arti_world",
    "cost": 3,
    "value": null,
    "meaning": "Artifact homeworld."
  },
  {
    "id": "cybernetic",
    "cost": 4,
    "value": null,
    "meaning": "Cybernetic food/production upkeep model."
  },
  {
    "id": "lithovore",
    "cost": 10,
    "value": null,
    "meaning": "Population does not need normal food."
  },
  {
    "id": "repulsive",
    "cost": -6,
    "value": null,
    "meaning": "Severe diplomacy/trade limitation."
  },
  {
    "id": "charismatic",
    "cost": 3,
    "value": null,
    "meaning": "Diplomacy/trade bonus."
  },
  {
    "id": "uncreative",
    "cost": -4,
    "value": null,
    "meaning": "Research selection penalty; random tech in field."
  },
  {
    "id": "creative",
    "cost": 8,
    "value": null,
    "meaning": "Research all techs in a field instead of choosing one."
  },
  {
    "id": "tolerant",
    "cost": 10,
    "value": null,
    "meaning": "Pollution/habitat/environmental tolerance bonus."
  },
  {
    "id": "fantastic_traders",
    "cost": 4,
    "value": null,
    "meaning": "Trade/income advantage."
  },
  {
    "id": "telepathic",
    "cost": 6,
    "value": null,
    "meaning": "Special diplomacy/conquest mechanics; verify exact conquest behavior."
  },
  {
    "id": "lucky",
    "cost": 3,
    "value": null,
    "meaning": "Random-event advantage."
  },
  {
    "id": "omniscient",
    "cost": 3,
    "value": null,
    "meaning": "Galaxy visibility/scouting advantage."
  },
  {
    "id": "stealthy_ships",
    "cost": 4,
    "value": null,
    "meaning": "Fleet stealth bonus."
  },
  {
    "id": "trans_dimensional",
    "cost": 5,
    "value": null,
    "meaning": "Movement/combat mobility bonus."
  },
  {
    "id": "warlord",
    "cost": 4,
    "value": null,
    "meaning": "Command/crew/combat advantage; includes CP bonus in parameter table."
  },
  {
    "id": "out_of_box_thinking",
    "cost": 3,
    "value": null,
    "meaning": "Out-of-the-Box Thinking: may buy skipped technologies from already-completed fields with research points (requires the matching game option)."
  }
] as const;

export const BUILDABLE_ROWS: readonly BuildableRow[] = [
  {
    "id": "marine_barracks",
    "techId": 107,
    "cost": 60,
    "maintenance": 1,
    "group": "government"
  },
  {
    "id": "hydroponic_farm",
    "techId": 86,
    "cost": 60,
    "maintenance": 2,
    "group": "food"
  },
  {
    "id": "habitat_domes",
    "techId": 27,
    "cost": 60,
    "maintenance": 1,
    "group": "food"
  },
  {
    "id": "habitat_dome_terraforming",
    "techId": 27,
    "cost": 50,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "population_growth_center",
    "techId": 37,
    "cost": 100,
    "maintenance": 2,
    "group": "special"
  },
  {
    "id": "soil_enrichment",
    "techId": 162,
    "cost": 150,
    "maintenance": 2,
    "group": "food"
  },
  {
    "id": "soil_enrichment_terraforming",
    "techId": 162,
    "cost": 50,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "subterranean_farms",
    "techId": 172,
    "cost": 120,
    "maintenance": 4,
    "group": "food"
  },
  {
    "id": "weather_controller",
    "techId": 199,
    "cost": 200,
    "maintenance": 3,
    "group": "food"
  },
  {
    "id": "artificial_planet",
    "techId": 16,
    "cost": 500,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "deep_core_mine",
    "techId": 45,
    "cost": 250,
    "maintenance": 3,
    "group": "production"
  },
  {
    "id": "core_waste_dump",
    "techId": 43,
    "cost": 200,
    "maintenance": 8,
    "group": "production"
  },
  {
    "id": "astro_university",
    "techId": 18,
    "cost": 250,
    "maintenance": 4,
    "group": "science"
  },
  {
    "id": "research_lab",
    "techId": 152,
    "cost": 60,
    "maintenance": 1,
    "group": "science"
  },
  {
    "id": "supercomputer",
    "techId": 178,
    "cost": 150,
    "maintenance": 2,
    "group": "science"
  },
  {
    "id": "autolab",
    "techId": 19,
    "cost": 250,
    "maintenance": 3,
    "group": "science"
  },
  {
    "id": "galactic_cybernet",
    "techId": 72,
    "cost": 1000,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "alien_management_center",
    "techId": 8,
    "cost": 120,
    "maintenance": 1,
    "group": "economy"
  },
  {
    "id": "space_academy",
    "techId": 164,
    "cost": 100,
    "maintenance": 1,
    "group": "government"
  },
  {
    "id": "galactic_currency_exchange",
    "techId": 73,
    "cost": 250,
    "maintenance": 5,
    "group": "economy"
  },
  {
    "id": "star_base",
    "techId": 167,
    "cost": 400,
    "maintenance": 2,
    "group": "defense"
  },
  {
    "id": "battle_station",
    "techId": 22,
    "cost": 1000,
    "maintenance": 3,
    "group": "defense"
  },
  {
    "id": "star_fortress",
    "techId": 169,
    "cost": 2500,
    "maintenance": 4,
    "group": "defense"
  },
  {
    "id": "missile_base",
    "techId": 109,
    "cost": 200,
    "maintenance": 2,
    "group": "defense"
  },
  {
    "id": "ground_batteries",
    "techId": 81,
    "cost": 250,
    "maintenance": 2,
    "group": "defense"
  },
  {
    "id": "fighter_garrison",
    "techId": 61,
    "cost": 150,
    "maintenance": 2,
    "group": "defense"
  },
  {
    "id": "stellar_safety_shield",
    "techId": 150,
    "cost": 80,
    "maintenance": 1,
    "group": "defense"
  },
  {
    "id": "flux_shield",
    "techId": 68,
    "cost": 300,
    "maintenance": 3,
    "group": "defense"
  },
  {
    "id": "planetary_stellar_safety_shield",
    "techId": 150,
    "cost": 250,
    "maintenance": 2,
    "group": "defense"
  },
  {
    "id": "planetary_flux_shield",
    "techId": 68,
    "cost": 750,
    "maintenance": 5,
    "group": "defense"
  },
  {
    "id": "planetary_barrier_shield",
    "techId": 129,
    "cost": 500,
    "maintenance": 3,
    "group": "defense"
  },
  {
    "id": "android_workers",
    "techId": 11,
    "cost": 120,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "android_farmers",
    "techId": 9,
    "cost": 120,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "android_scientists",
    "techId": 10,
    "cost": 120,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "automated_factory",
    "techId": 20,
    "cost": 60,
    "maintenance": 1,
    "group": "production"
  },
  {
    "id": "robo_miner_plant",
    "techId": 155,
    "cost": 200,
    "maintenance": 3,
    "group": "production"
  },
  {
    "id": "nanite_factory",
    "techId": 113,
    "cost": 300,
    "maintenance": 2,
    "group": "production"
  },
  {
    "id": "colony_base",
    "techId": 39,
    "cost": 200,
    "maintenance": 0,
    "group": "ship"
  },
  {
    "id": "colony_ship",
    "techId": 40,
    "cost": 500,
    "maintenance": 0,
    "group": "ship"
  },
  {
    "id": "construction_ship",
    "techId": 0,
    "cost": 400,
    "maintenance": 0,
    "group": "ship"
  },
  {
    "id": "outpost_ship",
    "techId": 122,
    "cost": 100,
    "maintenance": 0,
    "group": "ship"
  },
  {
    "id": "transport",
    "techId": 191,
    "cost": 100,
    "maintenance": 0,
    "group": "ship"
  },
  {
    "id": "freighter_fleet",
    "techId": 69,
    "cost": 100,
    "maintenance": 0,
    "group": "ship"
  },
  {
    "id": "spy",
    "techId": 166,
    "cost": 50,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "trade_goods",
    "techId": 187,
    "cost": 50,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "housing",
    "techId": 85,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "capitol",
    "techId": 34,
    "cost": 200,
    "maintenance": 0,
    "group": "government"
  },
  {
    "id": "pleasure_dome",
    "techId": 134,
    "cost": 250,
    "maintenance": 3,
    "group": "government"
  },
  {
    "id": "holo_simulator",
    "techId": 84,
    "cost": 120,
    "maintenance": 1,
    "group": "government"
  },
  {
    "id": "virtual_reality_network",
    "techId": 196,
    "cost": 250,
    "maintenance": 3,
    "group": "government"
  },
  {
    "id": "super_swarm",
    "techId": 177,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "spacetime_surfing",
    "techId": 0,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "re_population",
    "techId": 0,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "barrier",
    "techId": 0,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "stock_exchange",
    "techId": 173,
    "cost": 200,
    "maintenance": 2,
    "group": "economy"
  },
  {
    "id": "telepathic_training",
    "techId": 183,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "food_replicators",
    "techId": 64,
    "cost": 250,
    "maintenance": 10,
    "group": "food"
  },
  {
    "id": "gravity_generator",
    "techId": 77,
    "cost": 120,
    "maintenance": 2,
    "group": "special"
  },
  {
    "id": "dimensional_portal",
    "techId": 53,
    "cost": 500,
    "maintenance": 5,
    "group": "economy"
  },
  {
    "id": "atmospheric_renewer",
    "techId": 21,
    "cost": 100,
    "maintenance": 3,
    "group": "production"
  },
  {
    "id": "warp_interdictor",
    "techId": 198,
    "cost": 300,
    "maintenance": 4,
    "group": "defense"
  },
  {
    "id": "microlite_construction",
    "techId": 108,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "adaptive_habitat_lattice",
    "techId": 29,
    "cost": 0,
    "maintenance": 0,
    "group": "special"
  },
  {
    "id": "capitol_1",
    "techId": 34,
    "cost": 0,
    "maintenance": 0,
    "group": "government"
  },
  {
    "id": "capitol_2",
    "techId": 34,
    "cost": 0,
    "maintenance": 0,
    "group": "government"
  },
  {
    "id": "capitol_3",
    "techId": 34,
    "cost": 0,
    "maintenance": 0,
    "group": "government"
  },
  {
    "id": "capitol_4",
    "techId": 34,
    "cost": 0,
    "maintenance": 0,
    "group": "government"
  },
  {
    "id": "capitol_5",
    "techId": 34,
    "cost": 0,
    "maintenance": 0,
    "group": "government"
  },
  {
    "id": "marine_barracks_splinter",
    "techId": 107,
    "cost": 0,
    "maintenance": 0,
    "group": "government"
  },
  {
    "id": "armor_barracks_splinter",
    "techId": 0,
    "cost": 0,
    "maintenance": 0,
    "group": "government"
  }
] as const;

export const FIELD_ROWS: readonly FieldRow[] = [
  {
    "id": "advanced_ecology",
    "num": 1,
    "previous": 18,
    "next": 34,
    "cost": 400,
    "tier": 5,
    "general": false
  },
  {
    "id": "advanced_chemistry",
    "num": 2,
    "previous": 9,
    "next": 47,
    "cost": 650,
    "tier": 6,
    "general": false
  },
  {
    "id": "advanced_construction",
    "num": 3,
    "previous": 4,
    "next": 21,
    "cost": 150,
    "tier": 3,
    "general": false
  },
  {
    "id": "advanced_engineering",
    "num": 4,
    "previous": 29,
    "next": 3,
    "cost": 80,
    "tier": 2,
    "general": false
  },
  {
    "id": "advanced_fusion",
    "num": 5,
    "previous": 23,
    "next": 41,
    "cost": 250,
    "tier": 4,
    "general": false
  },
  {
    "id": "advanced_governments",
    "num": 6,
    "previous": 12,
    "next": 32,
    "cost": 4500,
    "tier": 13,
    "general": false
  },
  {
    "id": "advanced_magnetism",
    "num": 7,
    "previous": 0,
    "next": 36,
    "cost": 250,
    "tier": 4,
    "general": false
  },
  {
    "id": "advanced_manufacturing",
    "num": 8,
    "previous": 19,
    "next": 11,
    "cost": 1500,
    "tier": 9,
    "general": false
  },
  {
    "id": "advanced_metallurgy",
    "num": 9,
    "previous": 22,
    "next": 2,
    "cost": 250,
    "tier": 4,
    "general": false
  },
  {
    "id": "military_tactics",
    "num": 10,
    "previous": 0,
    "next": 73,
    "cost": 150,
    "tier": 3,
    "general": false
  },
  {
    "id": "advanced_robotics",
    "num": 11,
    "previous": 8,
    "next": 67,
    "cost": 2000,
    "tier": 10,
    "general": false
  },
  {
    "id": "teaching_methods",
    "num": 12,
    "previous": 43,
    "next": 6,
    "cost": 2000,
    "tier": 10,
    "general": false
  },
  {
    "id": "anti_matter_fission",
    "num": 13,
    "previous": 41,
    "next": 46,
    "cost": 2000,
    "tier": 10,
    "general": false
  },
  {
    "id": "artificial_consciousness",
    "num": 14,
    "previous": 60,
    "next": 25,
    "cost": 1500,
    "tier": 9,
    "general": false
  },
  {
    "id": "artificial_intelligence",
    "num": 15,
    "previous": 56,
    "next": 60,
    "cost": 400,
    "tier": 5,
    "general": false
  },
  {
    "id": "artificial_gravity",
    "num": 16,
    "previous": 54,
    "next": 65,
    "cost": 1150,
    "tier": 8,
    "general": false
  },
  {
    "id": "synthetic_ecosystems",
    "num": 17,
    "previous": 30,
    "next": 70,
    "cost": 4500,
    "tier": 13,
    "general": false
  },
  {
    "id": "astro_ecology",
    "num": 18,
    "previous": 0,
    "next": 1,
    "cost": 80,
    "tier": 2,
    "general": false
  },
  {
    "id": "astro_construction",
    "num": 19,
    "previous": 63,
    "next": 8,
    "cost": 1150,
    "tier": 8,
    "general": false
  },
  {
    "id": "astro_engineering",
    "num": 20,
    "previous": 21,
    "next": 62,
    "cost": 400,
    "tier": 5,
    "general": false
  },
  {
    "id": "capsule_construction",
    "num": 21,
    "previous": 3,
    "next": 20,
    "cost": 250,
    "tier": 4,
    "general": false
  },
  {
    "id": "chemistry",
    "num": 22,
    "previous": 0,
    "next": 9,
    "cost": 50,
    "tier": 1,
    "general": true
  },
  {
    "id": "cold_fusion",
    "num": 23,
    "previous": 55,
    "next": 5,
    "cost": 80,
    "tier": 2,
    "general": true
  },
  {
    "id": "cybertechnics",
    "num": 24,
    "previous": 25,
    "next": 33,
    "cost": 3500,
    "tier": 12,
    "general": false
  },
  {
    "id": "cybertronics",
    "num": 25,
    "previous": 14,
    "next": 24,
    "cost": 2750,
    "tier": 11,
    "general": false
  },
  {
    "id": "distortion_fields",
    "num": 26,
    "previous": 64,
    "next": 61,
    "cost": 3500,
    "tier": 12,
    "general": false
  },
  {
    "id": "electromagnetic_refraction",
    "num": 27,
    "previous": 45,
    "next": 72,
    "cost": 1500,
    "tier": 9,
    "general": false
  },
  {
    "id": "electronics",
    "num": 28,
    "previous": 0,
    "next": 56,
    "cost": 50,
    "tier": 1,
    "general": true
  },
  {
    "id": "engineering",
    "num": 29,
    "previous": 0,
    "next": 4,
    "cost": 50,
    "tier": 1,
    "general": true
  },
  {
    "id": "evolutionary_adaptation",
    "num": 30,
    "previous": 44,
    "next": 17,
    "cost": 2750,
    "tier": 11,
    "general": false
  },
  {
    "id": "fusion_physics",
    "num": 31,
    "previous": 57,
    "next": 66,
    "cost": 150,
    "tier": 3,
    "general": false
  },
  {
    "id": "galactic_economics",
    "num": 32,
    "previous": 6,
    "next": 82,
    "cost": 6000,
    "tier": 14,
    "general": false
  },
  {
    "id": "galactic_networking",
    "num": 33,
    "previous": 24,
    "next": 49,
    "cost": 4500,
    "tier": 13,
    "general": false
  },
  {
    "id": "trait_adaptation",
    "num": 34,
    "previous": 1,
    "next": 35,
    "cost": 900,
    "tier": 7,
    "general": false
  },
  {
    "id": "trait_variations",
    "num": 35,
    "previous": 34,
    "next": 44,
    "cost": 1150,
    "tier": 8,
    "general": false
  },
  {
    "id": "gravitic_fields",
    "num": 36,
    "previous": 7,
    "next": 45,
    "cost": 650,
    "tier": 6,
    "general": false
  },
  {
    "id": "high_energy_distribution",
    "num": 37,
    "previous": 46,
    "next": 38,
    "cost": 3500,
    "tier": 12,
    "general": false
  },
  {
    "id": "hyper_dimensional_fission",
    "num": 38,
    "previous": 37,
    "next": 40,
    "cost": 4500,
    "tier": 13,
    "general": false
  },
  {
    "id": "hyper_dimensional_physics",
    "num": 39,
    "previous": 51,
    "next": 69,
    "cost": 6000,
    "tier": 14,
    "general": false
  },
  {
    "id": "interphased_fission",
    "num": 40,
    "previous": 38,
    "next": 76,
    "cost": 10000,
    "tier": 16,
    "general": false
  },
  {
    "id": "ion_fission",
    "num": 41,
    "previous": 5,
    "next": 13,
    "cost": 900,
    "tier": 7,
    "general": false
  },
  {
    "id": "superscalar_construction",
    "num": 42,
    "previous": 67,
    "next": 58,
    "cost": 6000,
    "tier": 14,
    "general": false
  },
  {
    "id": "macro_economics",
    "num": 43,
    "previous": 73,
    "next": 12,
    "cost": 1150,
    "tier": 8,
    "general": false
  },
  {
    "id": "macro_adaptation",
    "num": 44,
    "previous": 35,
    "next": 30,
    "cost": 1500,
    "tier": 9,
    "general": false
  },
  {
    "id": "magneto_gravitics",
    "num": 45,
    "previous": 36,
    "next": 27,
    "cost": 900,
    "tier": 7,
    "general": false
  },
  {
    "id": "matter_energy_conversion",
    "num": 46,
    "previous": 13,
    "next": 37,
    "cost": 2750,
    "tier": 11,
    "general": false
  },
  {
    "id": "molecular_compression",
    "num": 47,
    "previous": 2,
    "next": 53,
    "cost": 1150,
    "tier": 8,
    "general": false
  },
  {
    "id": "molecular_control",
    "num": 48,
    "previous": 50,
    "next": 80,
    "cost": 10000,
    "tier": 16,
    "general": false
  },
  {
    "id": "moleculartronics",
    "num": 49,
    "previous": 33,
    "next": 81,
    "cost": 6000,
    "tier": 14,
    "general": false
  },
  {
    "id": "molecular_manipulation",
    "num": 50,
    "previous": 53,
    "next": 48,
    "cost": 4500,
    "tier": 13,
    "general": false
  },
  {
    "id": "multi_dimensional_physics",
    "num": 51,
    "previous": 59,
    "next": 39,
    "cost": 4500,
    "tier": 13,
    "general": false
  },
  {
    "id": "multi_phased_physics",
    "num": 52,
    "previous": 65,
    "next": 59,
    "cost": 2000,
    "tier": 10,
    "general": false
  },
  {
    "id": "nano_technology",
    "num": 53,
    "previous": 47,
    "next": 50,
    "cost": 2000,
    "tier": 10,
    "general": false
  },
  {
    "id": "neutrino_physics",
    "num": 54,
    "previous": 66,
    "next": 16,
    "cost": 900,
    "tier": 7,
    "general": false
  },
  {
    "id": "nuclear_fission",
    "num": 55,
    "previous": 0,
    "next": 23,
    "cost": 50,
    "tier": 1,
    "general": true
  },
  {
    "id": "optronics",
    "num": 56,
    "previous": 28,
    "next": 15,
    "cost": 150,
    "tier": 3,
    "general": false
  },
  {
    "id": "physics",
    "num": 57,
    "previous": 0,
    "next": 31,
    "cost": 50,
    "tier": 1,
    "general": true
  },
  {
    "id": "planetoid_construction",
    "num": 58,
    "previous": 42,
    "next": 78,
    "cost": 7500,
    "tier": 15,
    "general": false
  },
  {
    "id": "plasma_physics",
    "num": 59,
    "previous": 52,
    "next": 51,
    "cost": 3500,
    "tier": 12,
    "general": false
  },
  {
    "id": "positronics",
    "num": 60,
    "previous": 15,
    "next": 14,
    "cost": 900,
    "tier": 7,
    "general": false
  },
  {
    "id": "quantum_fields",
    "num": 61,
    "previous": 26,
    "next": 71,
    "cost": 4500,
    "tier": 13,
    "general": false
  },
  {
    "id": "robotics",
    "num": 62,
    "previous": 20,
    "next": 63,
    "cost": 650,
    "tier": 6,
    "general": false
  },
  {
    "id": "servo_mechanics",
    "num": 63,
    "previous": 62,
    "next": 19,
    "cost": 900,
    "tier": 7,
    "general": false
  },
  {
    "id": "subspace_fields",
    "num": 64,
    "previous": 72,
    "next": 26,
    "cost": 2750,
    "tier": 11,
    "general": false
  },
  {
    "id": "subspace_physics",
    "num": 65,
    "previous": 16,
    "next": 52,
    "cost": 1500,
    "tier": 9,
    "general": false
  },
  {
    "id": "tachyon_physics",
    "num": 66,
    "previous": 31,
    "next": 54,
    "cost": 250,
    "tier": 4,
    "general": false
  },
  {
    "id": "tectonic_engineering",
    "num": 67,
    "previous": 11,
    "next": 42,
    "cost": 3500,
    "tier": 12,
    "general": false
  },
  {
    "id": "temporal_fields",
    "num": 68,
    "previous": 71,
    "next": 79,
    "cost": 15000,
    "tier": 17,
    "general": false
  },
  {
    "id": "temporal_physics",
    "num": 69,
    "previous": 39,
    "next": 77,
    "cost": 15000,
    "tier": 17,
    "general": false
  },
  {
    "id": "trans_adaptation",
    "num": 70,
    "previous": 17,
    "next": 75,
    "cost": 7500,
    "tier": 15,
    "general": false
  },
  {
    "id": "transwarp_fields",
    "num": 71,
    "previous": 61,
    "next": 68,
    "cost": 7500,
    "tier": 15,
    "general": false
  },
  {
    "id": "warp_fields",
    "num": 72,
    "previous": 27,
    "next": 64,
    "cost": 2000,
    "tier": 10,
    "general": false
  },
  {
    "id": "xeno_relations",
    "num": 73,
    "previous": 10,
    "next": 43,
    "cost": 650,
    "tier": 6,
    "general": false
  },
  {
    "id": "xenon_technology",
    "num": 74,
    "previous": 74,
    "next": 74,
    "cost": 15000,
    "tier": 22,
    "general": false
  },
  {
    "id": "advf_ecology",
    "num": 75,
    "previous": 70,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  },
  {
    "id": "advf_power",
    "num": 76,
    "previous": 40,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  },
  {
    "id": "advf_physics",
    "num": 77,
    "previous": 69,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  },
  {
    "id": "advf_construction",
    "num": 78,
    "previous": 58,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  },
  {
    "id": "advf_fields",
    "num": 79,
    "previous": 68,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  },
  {
    "id": "advf_chemistry",
    "num": 80,
    "previous": 48,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  },
  {
    "id": "advf_computers",
    "num": 81,
    "previous": 49,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  },
  {
    "id": "advf_sociology",
    "num": 82,
    "previous": 32,
    "next": 0,
    "cost": 25000,
    "tier": 18,
    "general": false
  }
] as const;

export const FIELD_SUBJECTS: Readonly<Record<string, string>> = {
  "engineering": "construction",
  "advanced_engineering": "construction",
  "advanced_construction": "construction",
  "capsule_construction": "construction",
  "astro_engineering": "construction",
  "robotics": "construction",
  "servo_mechanics": "construction",
  "astro_construction": "construction",
  "advanced_manufacturing": "construction",
  "advanced_robotics": "construction",
  "tectonic_engineering": "construction",
  "superscalar_construction": "construction",
  "planetoid_construction": "construction",
  "advf_construction": "construction",
  "nuclear_fission": "power",
  "cold_fusion": "power",
  "advanced_fusion": "power",
  "ion_fission": "power",
  "anti_matter_fission": "power",
  "matter_energy_conversion": "power",
  "high_energy_distribution": "power",
  "hyper_dimensional_fission": "power",
  "interphased_fission": "power",
  "advf_power": "power",
  "chemistry": "chemistry",
  "advanced_metallurgy": "chemistry",
  "advanced_chemistry": "chemistry",
  "molecular_compression": "chemistry",
  "nano_technology": "chemistry",
  "molecular_manipulation": "chemistry",
  "molecular_control": "chemistry",
  "advf_chemistry": "chemistry",
  "military_tactics": "sociology",
  "xeno_relations": "sociology",
  "macro_economics": "sociology",
  "teaching_methods": "sociology",
  "advanced_governments": "sociology",
  "galactic_economics": "sociology",
  "advf_sociology": "sociology",
  "electronics": "computers",
  "optronics": "computers",
  "artificial_intelligence": "computers",
  "positronics": "computers",
  "artificial_consciousness": "computers",
  "cybertronics": "computers",
  "cybertechnics": "computers",
  "galactic_networking": "computers",
  "moleculartronics": "computers",
  "advf_computers": "computers",
  "astro_ecology": "ecology",
  "advanced_ecology": "ecology",
  "trait_adaptation": "ecology",
  "trait_variations": "ecology",
  "macro_adaptation": "ecology",
  "evolutionary_adaptation": "ecology",
  "synthetic_ecosystems": "ecology",
  "trans_adaptation": "ecology",
  "advf_ecology": "ecology",
  "physics": "physics",
  "fusion_physics": "physics",
  "tachyon_physics": "physics",
  "neutrino_physics": "physics",
  "artificial_gravity": "physics",
  "subspace_physics": "physics",
  "multi_phased_physics": "physics",
  "plasma_physics": "physics",
  "multi_dimensional_physics": "physics",
  "hyper_dimensional_physics": "physics",
  "temporal_physics": "physics",
  "advf_physics": "physics",
  "advanced_magnetism": "force_fields",
  "gravitic_fields": "force_fields",
  "magneto_gravitics": "force_fields",
  "electromagnetic_refraction": "force_fields",
  "warp_fields": "force_fields",
  "subspace_fields": "force_fields",
  "distortion_fields": "force_fields",
  "quantum_fields": "force_fields",
  "transwarp_fields": "force_fields",
  "temporal_fields": "force_fields",
  "advf_fields": "force_fields",
  "xenon_technology": "special"
} as const;

export const TECH_ROWS: readonly TechRow[] = [
  {
    "id": "alien_management_center",
    "techId": 8,
    "fieldNum": 73,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "anti_matter_bomb",
    "techId": 225,
    "fieldNum": 46,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "android_farmers",
    "techId": 9,
    "fieldNum": 25,
    "aiGroup": 2,
    "strategic": true
  },
  {
    "id": "android_scientists",
    "techId": 10,
    "fieldNum": 25,
    "aiGroup": 2,
    "strategic": true
  },
  {
    "id": "android_workers",
    "techId": 11,
    "fieldNum": 25,
    "aiGroup": 2,
    "strategic": true
  },
  {
    "id": "anti_matter_torpedo",
    "techId": 12,
    "fieldNum": 46,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "anti_missile_rocket",
    "techId": 13,
    "fieldNum": 31,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "anti_grav_harness",
    "techId": 14,
    "fieldNum": 16,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "achilles_targeting_unit",
    "techId": 15,
    "fieldNum": 39,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "artificial_planet_construction",
    "techId": 16,
    "fieldNum": 58,
    "aiGroup": 2,
    "strategic": true
  },
  {
    "id": "assault_shuttle",
    "techId": 17,
    "fieldNum": 63,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "astro_university",
    "techId": 18,
    "fieldNum": 73,
    "aiGroup": 5,
    "strategic": false
  },
  {
    "id": "autolab",
    "techId": 19,
    "fieldNum": 33,
    "aiGroup": 5,
    "strategic": false
  },
  {
    "id": "automated_factory",
    "techId": 20,
    "fieldNum": 3,
    "aiGroup": 2,
    "strategic": false
  },
  {
    "id": "atmospheric_renewer",
    "techId": 21,
    "fieldNum": 2,
    "aiGroup": 2,
    "strategic": false
  },
  {
    "id": "battle_pods",
    "techId": 22,
    "fieldNum": 45,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "battlestation",
    "techId": 23,
    "fieldNum": 20,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "battle_scanner",
    "techId": 24,
    "fieldNum": 28,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "class_i_shield",
    "techId": 25,
    "fieldNum": 7,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "class_iii_shield",
    "techId": 26,
    "fieldNum": 36,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "habitat_domes",
    "techId": 27,
    "fieldNum": 18,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "better_living_cascade",
    "techId": 28,
    "fieldNum": 70,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "adaptive_habitat_lattice",
    "techId": 29,
    "fieldNum": 80,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "black_hole_generator",
    "techId": 30,
    "fieldNum": 68,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "bomber_bays",
    "techId": 31,
    "fieldNum": 54,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "capitol",
    "techId": 34,
    "fieldNum": 29,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "class_v_shield",
    "techId": 35,
    "fieldNum": 45,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "class_vii_shield",
    "techId": 36,
    "fieldNum": 64,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "class_x_shield",
    "techId": 37,
    "fieldNum": 61,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "population_growth_center",
    "techId": 38,
    "fieldNum": 34,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "colony_base",
    "techId": 39,
    "fieldNum": 29,
    "aiGroup": 3,
    "strategic": false
  },
  {
    "id": "colony_ship",
    "techId": 40,
    "fieldNum": 29,
    "aiGroup": 3,
    "strategic": false
  },
  {
    "id": "cruiser",
    "techId": 42,
    "fieldNum": 21,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "cyber_security_link",
    "techId": 43,
    "fieldNum": 33,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "cybertronic_computer",
    "techId": 44,
    "fieldNum": 24,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "deep_core_mine",
    "techId": 45,
    "fieldNum": 67,
    "aiGroup": 2,
    "strategic": false
  },
  {
    "id": "starlight_projector",
    "techId": 47,
    "fieldNum": 74,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "tech_detox_pods",
    "techId": 48,
    "fieldNum": 35,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "deuterium_fuel_cells",
    "techId": 49,
    "fieldNum": 23,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "doom_star_construction",
    "techId": 50,
    "fieldNum": 58,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "cruiser_class_shield",
    "techId": 51,
    "fieldNum": 37,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "damper_field",
    "techId": 52,
    "fieldNum": 71,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "dimensional_portal",
    "techId": 53,
    "fieldNum": 26,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "disruptor_cannon",
    "techId": 54,
    "fieldNum": 48,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "displacement_device",
    "techId": 55,
    "fieldNum": 51,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "electronic_computer",
    "techId": 56,
    "fieldNum": 28,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "emissions_guidance_system",
    "techId": 57,
    "fieldNum": 72,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "fast_missile_racks",
    "techId": 58,
    "fieldNum": 72,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "fighter_bays",
    "techId": 59,
    "fieldNum": 31,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "neutronium_armor",
    "techId": 60,
    "fieldNum": 50,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "fighter_garrison",
    "techId": 61,
    "fieldNum": 54,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "fire_control_center",
    "techId": 62,
    "fieldNum": 64,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "fleet_support_base",
    "techId": 63,
    "fieldNum": 7,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "food_replicators",
    "techId": 64,
    "fieldNum": 46,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "freighters",
    "techId": 69,
    "fieldNum": 29,
    "aiGroup": 3,
    "strategic": false
  },
  {
    "id": "fusion_beam",
    "techId": 70,
    "fieldNum": 31,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "fusion_bomb",
    "techId": 71,
    "fieldNum": 5,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "fusion_drive",
    "techId": 72,
    "fieldNum": 5,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "galactic_currency_exchange",
    "techId": 73,
    "fieldNum": 32,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "gauss_cannon",
    "techId": 78,
    "fieldNum": 9,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "graviton_beam",
    "techId": 79,
    "fieldNum": 36,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "gyro_destabilizer",
    "techId": 80,
    "fieldNum": 16,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "ground_batteries",
    "techId": 81,
    "fieldNum": 27,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "hard_shields",
    "techId": 82,
    "fieldNum": 39,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "heavy_fighter_bays",
    "techId": 83,
    "fieldNum": 54,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "holo_simulator",
    "techId": 84,
    "fieldNum": 73,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "housing",
    "techId": 85,
    "fieldNum": 29,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "hydroponic_farm",
    "techId": 86,
    "fieldNum": 18,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "hyper_drive",
    "techId": 87,
    "fieldNum": 69,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "hyper_x_capacitors",
    "techId": 88,
    "fieldNum": 69,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "inertia_nullifier",
    "techId": 89,
    "fieldNum": 51,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "inertial_stabilizer",
    "techId": 90,
    "fieldNum": 27,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "interceptor_bays",
    "techId": 91,
    "fieldNum": 31,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "ion_drive",
    "techId": 92,
    "fieldNum": 41,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "iridium_fuel_cells",
    "techId": 93,
    "fieldNum": 41,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "jump_gate",
    "techId": 94,
    "fieldNum": 64,
    "aiGroup": 3,
    "strategic": false
  },
  {
    "id": "space_scanner",
    "techId": 95,
    "fieldNum": 29,
    "aiGroup": 3,
    "strategic": false
  },
  {
    "id": "neutron_scanner",
    "techId": 96,
    "fieldNum": 60,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "ion_pulse_cannon",
    "techId": 97,
    "fieldNum": 45,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "plasma_scanner",
    "techId": 98,
    "fieldNum": 60,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "tachyon_scanner",
    "techId": 99,
    "fieldNum": 66,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "laser_cannon",
    "techId": 100,
    "fieldNum": 28,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "laser_rifle",
    "techId": 101,
    "fieldNum": 28,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "lightning_field",
    "techId": 102,
    "fieldNum": 51,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "mauler_device",
    "techId": 105,
    "fieldNum": 68,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "merculite_missiles",
    "techId": 106,
    "fieldNum": 22,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "marine_barracks",
    "techId": 107,
    "fieldNum": 29,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "mass_driver",
    "techId": 104,
    "fieldNum": 22,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "microlite_construction",
    "techId": 108,
    "fieldNum": 78,
    "aiGroup": 2,
    "strategic": false
  },
  {
    "id": "missile_base",
    "techId": 109,
    "fieldNum": 22,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "multi_phased_shields",
    "techId": 110,
    "fieldNum": 61,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "multi_wave_ecm_jammer",
    "techId": 111,
    "fieldNum": 65,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "neutron_blaster",
    "techId": 115,
    "fieldNum": 34,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "nano_disassemblers",
    "techId": 116,
    "fieldNum": 53,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "neutronium_bomb",
    "techId": 118,
    "fieldNum": 50,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "neutronium_battle_suit",
    "techId": 117,
    "fieldNum": 50,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "nuclear_bomb",
    "techId": 119,
    "fieldNum": 55,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "nuclear_drive",
    "techId": 120,
    "fieldNum": 55,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "nuclear_missile",
    "techId": 121,
    "fieldNum": 55,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "outpost_ship",
    "techId": 122,
    "fieldNum": 29,
    "aiGroup": 3,
    "strategic": false
  },
  {
    "id": "particle_beam",
    "techId": 123,
    "fieldNum": 59,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "neutron_pellet_gun",
    "techId": 114,
    "fieldNum": 1,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "battleoids",
    "techId": 224,
    "fieldNum": 67,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "personal_shield",
    "techId": 126,
    "fieldNum": 7,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "phasors",
    "techId": 127,
    "fieldNum": 52,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "phasing_cloak",
    "techId": 128,
    "fieldNum": 39,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "planetary_barrier_shield",
    "techId": 129,
    "fieldNum": 26,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "planetary_flux_shield",
    "techId": 130,
    "fieldNum": 68,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "planetary_gravity_generator",
    "techId": 131,
    "fieldNum": 16,
    "aiGroup": 2,
    "strategic": false
  },
  {
    "id": "planetary_stellar_safety_shield",
    "techId": 132,
    "fieldNum": 2,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "plasma_cannon",
    "techId": 137,
    "fieldNum": 59,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "plasma_rifle",
    "techId": 138,
    "fieldNum": 59,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "plasma_torpedoes",
    "techId": 139,
    "fieldNum": 66,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "plasma_web",
    "techId": 140,
    "fieldNum": 72,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "pollution_processor",
    "techId": 141,
    "fieldNum": 19,
    "aiGroup": 2,
    "strategic": false
  },
  {
    "id": "positronic_computer",
    "techId": 142,
    "fieldNum": 60,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "proton_torpedoes",
    "techId": 146,
    "fieldNum": 54,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "pulson_missiles",
    "techId": 149,
    "fieldNum": 47,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "stellar_safety_shield",
    "techId": 150,
    "fieldNum": 2,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "reinforced_hull",
    "techId": 151,
    "fieldNum": 29,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "research_lab",
    "techId": 152,
    "fieldNum": 28,
    "aiGroup": 5,
    "strategic": false
  },
  {
    "id": "robominers",
    "techId": 155,
    "fieldNum": 62,
    "aiGroup": 2,
    "strategic": false
  },
  {
    "id": "scout_lab",
    "techId": 156,
    "fieldNum": 18,
    "aiGroup": 5,
    "strategic": false
  },
  {
    "id": "sensor_cluster",
    "techId": 157,
    "fieldNum": 37,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "shield_capacitor",
    "techId": 158,
    "fieldNum": 39,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "shield_piercing",
    "techId": 159,
    "fieldNum": 65,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "space_academy",
    "techId": 164,
    "fieldNum": 10,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "space_port",
    "techId": 163,
    "fieldNum": 43,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "space_time_crystal",
    "techId": 161,
    "fieldNum": 74,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "soil_enrichment",
    "techId": 162,
    "fieldNum": 1,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "spacetime_surfing",
    "techId": 0,
    "fieldNum": 77,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "spatial_compressor",
    "techId": 165,
    "fieldNum": 16,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "spies",
    "techId": 166,
    "fieldNum": 28,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "star_base",
    "techId": 167,
    "fieldNum": 29,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "star_fortress",
    "techId": 169,
    "fieldNum": 42,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "stealth_field",
    "techId": 170,
    "fieldNum": 26,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "stasis_field",
    "techId": 171,
    "fieldNum": 71,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "stock_exchange",
    "techId": 173,
    "fieldNum": 6,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "stellar_converter",
    "techId": 174,
    "fieldNum": 40,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "neutronium_fighter_garrison",
    "techId": 175,
    "fieldNum": 69,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "neutronium_fighters",
    "techId": 176,
    "fieldNum": 69,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "supercomputer",
    "techId": 178,
    "fieldNum": 56,
    "aiGroup": 5,
    "strategic": false
  },
  {
    "id": "superscalar_construction",
    "techId": 179,
    "fieldNum": 42,
    "aiGroup": 2,
    "strategic": true
  },
  {
    "id": "transporters",
    "techId": 180,
    "fieldNum": 45,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "structural_analyzer",
    "techId": 181,
    "fieldNum": 65,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "sub_space_teleporter",
    "techId": 182,
    "fieldNum": 26,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "telepathic_training",
    "techId": 183,
    "fieldNum": 75,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "terraforming",
    "techId": 184,
    "fieldNum": 1,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "thorium_fuel_cells",
    "techId": 185,
    "fieldNum": 38,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "titan_construction",
    "techId": 186,
    "fieldNum": 8,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "trade_goods",
    "techId": 187,
    "fieldNum": 29,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "tractor_beam",
    "techId": 188,
    "fieldNum": 45,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "tritanium_armor",
    "techId": 189,
    "fieldNum": 9,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "tritanium_battle_suit",
    "techId": 190,
    "fieldNum": 9,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "transport",
    "techId": 191,
    "fieldNum": 29,
    "aiGroup": 3,
    "strategic": false
  },
  {
    "id": "universal_antidote",
    "techId": 192,
    "fieldNum": 70,
    "aiGroup": 6,
    "strategic": false
  },
  {
    "id": "uridium_fuel_cells",
    "techId": 193,
    "fieldNum": 13,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "virtual_reality_network",
    "techId": 196,
    "fieldNum": 43,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "warp_dissipater",
    "techId": 197,
    "fieldNum": 52,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "warp_interdictor",
    "techId": 198,
    "fieldNum": 72,
    "aiGroup": 7,
    "strategic": false
  },
  {
    "id": "weather_controller",
    "techId": 199,
    "fieldNum": 30,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "wide_area_jammer",
    "techId": 200,
    "fieldNum": 52,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "xentronium_armor",
    "techId": 201,
    "fieldNum": 74,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "zeon_missile",
    "techId": 202,
    "fieldNum": 53,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "hyper_advanced_ecology",
    "techId": 203,
    "fieldNum": 75,
    "aiGroup": 4,
    "strategic": false
  },
  {
    "id": "hyper_advanced_power",
    "techId": 204,
    "fieldNum": 76,
    "aiGroup": 3,
    "strategic": true
  },
  {
    "id": "hyper_advanced_physics",
    "techId": 205,
    "fieldNum": 77,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "hyper_advanced_construction",
    "techId": 206,
    "fieldNum": 78,
    "aiGroup": 2,
    "strategic": true
  },
  {
    "id": "hyper_advanced_force_fields",
    "techId": 207,
    "fieldNum": 79,
    "aiGroup": 7,
    "strategic": true
  },
  {
    "id": "hyper_advanced_chemistry",
    "techId": 208,
    "fieldNum": 80,
    "aiGroup": 6,
    "strategic": true
  },
  {
    "id": "hyper_advanced_computers",
    "techId": 209,
    "fieldNum": 81,
    "aiGroup": 5,
    "strategic": true
  },
  {
    "id": "hyper_advanced_sociology",
    "techId": 210,
    "fieldNum": 82,
    "aiGroup": 1,
    "strategic": false
  },
  {
    "id": "gaia_transformation",
    "techId": 211,
    "fieldNum": 17,
    "aiGroup": 4,
    "strategic": false
  }
] as const;

export const HULL_ROWS: readonly HullRow[] = [
  {
    "id": "frigate",
    "cost": 20,
    "space": 25,
    "marines": 5,
    "armorHp": 4,
    "structureHp": 4,
    "computerHp": 1,
    "driveHp": 2,
    "shieldHp": 1,
    "strategic": {
      "beam": 1,
      "missile": 0,
      "special": 0,
      "bomb": 0,
      "defBonus": 50,
      "hits": 4
    }
  },
  {
    "id": "destroyer",
    "cost": 70,
    "space": 60,
    "marines": 8,
    "armorHp": 10,
    "structureHp": 10,
    "computerHp": 2,
    "driveHp": 5,
    "shieldHp": 2,
    "strategic": {
      "beam": 2,
      "missile": 0,
      "special": 0,
      "bomb": 0,
      "defBonus": 40,
      "hits": 15
    }
  },
  {
    "id": "cruiser",
    "cost": 250,
    "space": 120,
    "marines": 12,
    "armorHp": 30,
    "structureHp": 30,
    "computerHp": 5,
    "driveHp": 10,
    "shieldHp": 6,
    "strategic": {
      "beam": 2,
      "missile": 1,
      "special": 0,
      "bomb": 2,
      "defBonus": 30,
      "hits": 25
    }
  },
  {
    "id": "battleship",
    "cost": 600,
    "space": 250,
    "marines": 20,
    "armorHp": 50,
    "structureHp": 50,
    "computerHp": 7,
    "driveHp": 15,
    "shieldHp": 7,
    "strategic": {
      "beam": 4,
      "missile": 2,
      "special": 1,
      "bomb": 5,
      "defBonus": 25,
      "hits": 40
    }
  },
  {
    "id": "titan",
    "cost": 1500,
    "space": 500,
    "marines": 30,
    "armorHp": 80,
    "structureHp": 80,
    "computerHp": 10,
    "driveHp": 20,
    "shieldHp": 10,
    "strategic": {
      "beam": 6,
      "missile": 4,
      "special": 3,
      "bomb": 10,
      "defBonus": 20,
      "hits": 80
    }
  },
  {
    "id": "doomstar",
    "cost": 4000,
    "space": 1200,
    "marines": 50,
    "armorHp": 150,
    "structureHp": 150,
    "computerHp": 20,
    "driveHp": 40,
    "shieldHp": 20,
    "strategic": {
      "beam": 10,
      "missile": 10,
      "special": 5,
      "bomb": 25,
      "defBonus": 15,
      "hits": 300
    }
  },
  {
    "id": "star_base",
    "cost": 400,
    "space": 400,
    "marines": 20,
    "armorHp": 60,
    "structureHp": 60,
    "computerHp": 10,
    "driveHp": 0,
    "shieldHp": 15,
    "strategic": {
      "beam": 3,
      "missile": 3,
      "special": 0,
      "bomb": 0,
      "defBonus": -10,
      "hits": 100
    }
  },
  {
    "id": "battlestation",
    "cost": 1000,
    "space": 800,
    "marines": 40,
    "armorHp": 90,
    "structureHp": 90,
    "computerHp": 15,
    "driveHp": 0,
    "shieldHp": 20,
    "strategic": {
      "beam": 6,
      "missile": 6,
      "special": 0,
      "bomb": 0,
      "defBonus": -10,
      "hits": 200
    }
  },
  {
    "id": "star_fortress",
    "cost": 2500,
    "space": 1600,
    "marines": 80,
    "armorHp": 120,
    "structureHp": 120,
    "computerHp": 20,
    "driveHp": 0,
    "shieldHp": 30,
    "strategic": {
      "beam": 10,
      "missile": 10,
      "special": 0,
      "bomb": 0,
      "defBonus": -10,
      "hits": 500
    }
  }
] as const;

export const WEAPON_ROWS: readonly WeaponRow[] = [
  {
    "id": "mass_driver",
    "techId": 104,
    "classId": 0,
    "ammo": -1,
    "space": 10,
    "cost": 7,
    "naturalMods": [
      "nr"
    ],
    "tacticalDamage": {
      "min": 6,
      "max": 6
    },
    "strategicDamage": {
      "min": 6,
      "max": 6
    },
    "availableMods": [
      "hv",
      "pd",
      "ap",
      "af"
    ]
  },
  {
    "id": "gauss_cannon",
    "techId": 78,
    "classId": 0,
    "ammo": -1,
    "space": 10,
    "cost": 10,
    "naturalMods": [
      "nr"
    ],
    "tacticalDamage": {
      "min": 18,
      "max": 18
    },
    "strategicDamage": {
      "min": 18,
      "max": 18
    },
    "availableMods": [
      "hv",
      "ap",
      "af"
    ]
  },
  {
    "id": "laser_cannon",
    "techId": 100,
    "classId": 0,
    "ammo": -1,
    "space": 10,
    "cost": 5,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 1,
      "max": 4
    },
    "strategicDamage": {
      "min": 1,
      "max": 4
    },
    "availableMods": [
      "hv",
      "pd",
      "ap",
      "co",
      "nr",
      "af"
    ]
  },
  {
    "id": "particle_beam",
    "techId": 123,
    "classId": 0,
    "ammo": -1,
    "space": 15,
    "cost": 35,
    "naturalMods": [
      "sp"
    ],
    "tacticalDamage": {
      "min": 10,
      "max": 30
    },
    "strategicDamage": {
      "min": 10,
      "max": 30
    },
    "availableMods": [
      "hv",
      "pd",
      "co"
    ]
  },
  {
    "id": "fusion_beam",
    "techId": 70,
    "classId": 0,
    "ammo": -1,
    "space": 10,
    "cost": 6,
    "naturalMods": [
      "dr"
    ],
    "tacticalDamage": {
      "min": 2,
      "max": 6
    },
    "strategicDamage": {
      "min": 2,
      "max": 6
    },
    "availableMods": [
      "hv",
      "pd",
      "co",
      "env"
    ]
  },
  {
    "id": "ion_pulse_cannon",
    "techId": 97,
    "classId": 0,
    "ammo": -1,
    "space": 30,
    "cost": 15,
    "naturalMods": [
      "ion"
    ],
    "tacticalDamage": {
      "min": 2,
      "max": 10
    },
    "strategicDamage": {
      "min": 2,
      "max": 10
    },
    "availableMods": [
      "co",
      "af"
    ]
  },
  {
    "id": "graviton_beam",
    "techId": 79,
    "classId": 0,
    "ammo": -1,
    "space": 15,
    "cost": 12,
    "naturalMods": [
      "esd"
    ],
    "tacticalDamage": {
      "min": 3,
      "max": 15
    },
    "strategicDamage": {
      "min": 3,
      "max": 15
    },
    "availableMods": [
      "hv",
      "co"
    ]
  },
  {
    "id": "neutron_blaster",
    "techId": 115,
    "classId": 0,
    "ammo": -1,
    "space": 10,
    "cost": 8,
    "naturalMods": [
      "mar"
    ],
    "tacticalDamage": {
      "min": 3,
      "max": 12
    },
    "strategicDamage": {
      "min": 3,
      "max": 12
    },
    "availableMods": [
      "hv",
      "co"
    ]
  },
  {
    "id": "phasor",
    "techId": 127,
    "classId": 0,
    "ammo": -1,
    "space": 10,
    "cost": 10,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 5,
      "max": 20
    },
    "strategicDamage": {
      "min": 5,
      "max": 20
    },
    "availableMods": [
      "hv",
      "pd",
      "co",
      "sp",
      "af"
    ]
  },
  {
    "id": "disrupter",
    "techId": 54,
    "classId": 0,
    "ammo": -1,
    "space": 20,
    "cost": 25,
    "naturalMods": [
      "nr"
    ],
    "tacticalDamage": {
      "min": 40,
      "max": 40
    },
    "strategicDamage": {
      "min": 40,
      "max": 40
    },
    "availableMods": [
      "hv",
      "af"
    ]
  },
  {
    "id": "starlight_projector",
    "techId": 47,
    "classId": 0,
    "ammo": -1,
    "space": 30,
    "cost": 75,
    "naturalMods": [
      "mar",
      "co"
    ],
    "tacticalDamage": {
      "min": 50,
      "max": 100
    },
    "strategicDamage": {
      "min": 50,
      "max": 100
    },
    "availableMods": [
      "hv"
    ]
  },
  {
    "id": "plasma_cannon",
    "techId": 137,
    "classId": 0,
    "ammo": -1,
    "space": 25,
    "cost": 15,
    "naturalMods": [
      "dr",
      "env"
    ],
    "tacticalDamage": {
      "min": 6,
      "max": 30
    },
    "strategicDamage": {
      "min": 6,
      "max": 30
    },
    "availableMods": [
      "hv",
      "co"
    ]
  },
  {
    "id": "spatial_compressor",
    "techId": 165,
    "classId": 5,
    "ammo": -1,
    "space": 50,
    "cost": 40,
    "naturalMods": [
      "ai2"
    ],
    "tacticalDamage": {
      "min": 4,
      "max": 32
    },
    "strategicDamage": {
      "min": 5,
      "max": 40
    },
    "availableMods": []
  },
  {
    "id": "nuclear_missile",
    "techId": 121,
    "classId": 1,
    "ammo": 5,
    "space": 0,
    "cost": 0,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 8,
      "max": 8
    },
    "strategicDamage": {
      "min": 8,
      "max": 8
    },
    "availableMods": [
      "mv",
      "eccm",
      "arm",
      "fst",
      "emg"
    ]
  },
  {
    "id": "merculite_missile",
    "techId": 106,
    "classId": 1,
    "ammo": 5,
    "space": 0,
    "cost": 0,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 14,
      "max": 14
    },
    "strategicDamage": {
      "min": 14,
      "max": 14
    },
    "availableMods": [
      "mv",
      "eccm",
      "arm",
      "fst",
      "emg"
    ]
  },
  {
    "id": "pulson_missile",
    "techId": 149,
    "classId": 1,
    "ammo": 5,
    "space": 0,
    "cost": 0,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 20,
      "max": 20
    },
    "strategicDamage": {
      "min": 20,
      "max": 20
    },
    "availableMods": [
      "mv",
      "eccm",
      "arm",
      "fst",
      "emg"
    ]
  },
  {
    "id": "zeon_missile",
    "techId": 202,
    "classId": 1,
    "ammo": 5,
    "space": 0,
    "cost": 0,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 30,
      "max": 30
    },
    "strategicDamage": {
      "min": 30,
      "max": 30
    },
    "availableMods": [
      "mv",
      "eccm",
      "arm",
      "fst",
      "emg"
    ]
  },
  {
    "id": "anti_matter_torpedo",
    "techId": 12,
    "classId": 2,
    "ammo": 2,
    "space": 20,
    "cost": 15,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 25,
      "max": 25
    },
    "strategicDamage": {
      "min": 25,
      "max": 25
    },
    "availableMods": [
      "env",
      "eccm",
      "ovr"
    ]
  },
  {
    "id": "proton_torpedo",
    "techId": 146,
    "classId": 2,
    "ammo": 2,
    "space": 30,
    "cost": 20,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 40,
      "max": 40
    },
    "strategicDamage": {
      "min": 40,
      "max": 40
    },
    "availableMods": [
      "env",
      "eccm",
      "ovr"
    ]
  },
  {
    "id": "plasma_torpedo",
    "techId": 139,
    "classId": 2,
    "ammo": 2,
    "space": 40,
    "cost": 75,
    "naturalMods": [
      "ai1"
    ],
    "tacticalDamage": {
      "min": 120,
      "max": 120
    },
    "strategicDamage": {
      "min": 120,
      "max": 120
    },
    "availableMods": [
      "nr",
      "env",
      "eccm",
      "ovr"
    ]
  },
  {
    "id": "nuclear_bomb",
    "techId": 119,
    "classId": 3,
    "ammo": 10,
    "space": 5,
    "cost": 3,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 3,
      "max": 12
    },
    "strategicDamage": {
      "min": 3,
      "max": 12
    },
    "availableMods": []
  },
  {
    "id": "fusion_bomb",
    "techId": 71,
    "classId": 3,
    "ammo": 10,
    "space": 7,
    "cost": 5,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 4,
      "max": 24
    },
    "strategicDamage": {
      "min": 4,
      "max": 24
    },
    "availableMods": []
  },
  {
    "id": "anti_matter_bomb",
    "techId": 10,
    "classId": 3,
    "ammo": 10,
    "space": 7,
    "cost": 6,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 5,
      "max": 40
    },
    "strategicDamage": {
      "min": 5,
      "max": 40
    },
    "availableMods": []
  },
  {
    "id": "neutronium_bomb",
    "techId": 118,
    "classId": 3,
    "ammo": 10,
    "space": 10,
    "cost": 9,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 10,
      "max": 60
    },
    "strategicDamage": {
      "min": 10,
      "max": 60
    },
    "availableMods": []
  },
  {
    "id": "tech_detox_pod",
    "techId": 48,
    "classId": 3,
    "ammo": 10,
    "space": 5,
    "cost": 5,
    "naturalMods": [
      "morale"
    ],
    "tacticalDamage": {
      "min": 10,
      "max": 10
    },
    "strategicDamage": {
      "min": 10,
      "max": 10
    },
    "availableMods": []
  },
  {
    "id": "better_living_cascade",
    "techId": 28,
    "classId": 3,
    "ammo": 10,
    "space": 7,
    "cost": 8,
    "naturalMods": [
      "morale"
    ],
    "tacticalDamage": {
      "min": 20,
      "max": 20
    },
    "strategicDamage": {
      "min": 20,
      "max": 20
    },
    "availableMods": []
  },
  {
    "id": "mauler_device",
    "techId": 105,
    "classId": 0,
    "ammo": -1,
    "space": 50,
    "cost": 75,
    "naturalMods": [
      "hit"
    ],
    "tacticalDamage": {
      "min": 100,
      "max": 100
    },
    "strategicDamage": {
      "min": 100,
      "max": 100
    },
    "availableMods": [
      "hv"
    ]
  },
  {
    "id": "assault_shuttle",
    "techId": 17,
    "classId": 4,
    "ammo": 1,
    "space": 25,
    "cost": 10,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 0,
      "max": 0
    },
    "strategicDamage": {
      "min": 0,
      "max": 0
    },
    "availableMods": []
  },
  {
    "id": "heavy_fighter",
    "techId": 83,
    "classId": 4,
    "ammo": 1,
    "space": 80,
    "cost": 50,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 0,
      "max": 0
    },
    "strategicDamage": {
      "min": 8,
      "max": 32
    },
    "availableMods": []
  },
  {
    "id": "bomber",
    "techId": 31,
    "classId": 4,
    "ammo": 1,
    "space": 60,
    "cost": 30,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 0,
      "max": 0
    },
    "strategicDamage": {
      "min": 5,
      "max": 20
    },
    "availableMods": []
  },
  {
    "id": "interceptor",
    "techId": 66,
    "classId": 4,
    "ammo": 1,
    "space": 30,
    "cost": 10,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 0,
      "max": 0
    },
    "strategicDamage": {
      "min": 1,
      "max": 4
    },
    "availableMods": []
  },
  {
    "id": "stasis_field",
    "techId": 171,
    "classId": 5,
    "ammo": -1,
    "space": 75,
    "cost": 75,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 0,
      "max": 0
    },
    "strategicDamage": {
      "min": 0,
      "max": 0
    },
    "availableMods": []
  },
  {
    "id": "anti_missile_rocket",
    "techId": 13,
    "classId": 5,
    "ammo": 20,
    "space": 20,
    "cost": 5,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 0,
      "max": 0
    },
    "strategicDamage": {
      "min": 0,
      "max": 0
    },
    "availableMods": []
  },
  {
    "id": "gyro_destabilizer",
    "techId": 80,
    "classId": 5,
    "ammo": -1,
    "space": 75,
    "cost": 50,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 1,
      "max": 4
    },
    "strategicDamage": {
      "min": 3,
      "max": 8
    },
    "availableMods": []
  },
  {
    "id": "plasma_web",
    "techId": 140,
    "classId": 5,
    "ammo": -1,
    "space": 40,
    "cost": 40,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 5,
      "max": 25
    },
    "strategicDamage": {
      "min": 5,
      "max": 25
    },
    "availableMods": []
  },
  {
    "id": "pulsar",
    "techId": 148,
    "classId": 5,
    "ammo": -1,
    "space": 50,
    "cost": 30,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 2,
      "max": 24
    },
    "strategicDamage": {
      "min": 4,
      "max": 20
    },
    "availableMods": []
  },
  {
    "id": "black_hole_generator",
    "techId": 30,
    "classId": 5,
    "ammo": -1,
    "space": 150,
    "cost": 150,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 100,
      "max": 100
    },
    "strategicDamage": {
      "min": 100,
      "max": 100
    },
    "availableMods": []
  },
  {
    "id": "stellar_converter",
    "techId": 174,
    "classId": 5,
    "ammo": -1,
    "space": 500,
    "cost": 500,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 400,
      "max": 400
    },
    "strategicDamage": {
      "min": 250,
      "max": 250
    },
    "availableMods": []
  },
  {
    "id": "tractor_beam",
    "techId": 188,
    "classId": 5,
    "ammo": -1,
    "space": 30,
    "cost": 20,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 0,
      "max": 0
    },
    "strategicDamage": {
      "min": 0,
      "max": 0
    },
    "availableMods": []
  },
  {
    "id": "dragon_breath",
    "techId": 0,
    "classId": 2,
    "ammo": 1,
    "space": 25,
    "cost": 20,
    "naturalMods": [
      "hit"
    ],
    "tacticalDamage": {
      "min": 300,
      "max": 300
    },
    "strategicDamage": {
      "min": 250,
      "max": 250
    },
    "availableMods": [
      "hv"
    ]
  },
  {
    "id": "phasor_eye",
    "techId": 0,
    "classId": 0,
    "ammo": -1,
    "space": 10,
    "cost": 10,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 5,
      "max": 10
    },
    "strategicDamage": {
      "min": 5,
      "max": 10
    },
    "availableMods": [
      "hv",
      "pd",
      "co",
      "sp",
      "af"
    ]
  },
  {
    "id": "crystal_ray",
    "techId": 0,
    "classId": 0,
    "ammo": -1,
    "space": 60,
    "cost": 75,
    "naturalMods": [
      "mar"
    ],
    "tacticalDamage": {
      "min": 40,
      "max": 80
    },
    "strategicDamage": {
      "min": 40,
      "max": 80
    },
    "availableMods": [
      "hv",
      "co"
    ]
  },
  {
    "id": "plasma_breath",
    "techId": 0,
    "classId": 0,
    "ammo": -1,
    "space": 50,
    "cost": 75,
    "naturalMods": [
      "hit"
    ],
    "tacticalDamage": {
      "min": 60,
      "max": 60
    },
    "strategicDamage": {
      "min": 60,
      "max": 60
    },
    "availableMods": [
      "hv"
    ]
  },
  {
    "id": "plasma_flux",
    "techId": 0,
    "classId": 5,
    "ammo": -1,
    "space": 250,
    "cost": 100,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 10,
      "max": 40
    },
    "strategicDamage": {
      "min": 10,
      "max": 40
    },
    "availableMods": []
  },
  {
    "id": "caustic_slime",
    "techId": 0,
    "classId": 5,
    "ammo": -1,
    "space": 300,
    "cost": 100,
    "naturalMods": [],
    "tacticalDamage": {
      "min": 25,
      "max": 50
    },
    "strategicDamage": {
      "min": 25,
      "max": 50
    },
    "availableMods": []
  }
] as const;

export const WEAPON_MOD_ROWS: readonly WeaponModRow[] = [
  {
    "id": "heavy_mount",
    "modId": 1,
    "miniaturizationLevel": 0,
    "spacePercent": 100,
    "costPercent": 100,
    "damageMultiplier": 1,
    "hint": "Heavy mount: +50% damage and longer beam reach."
  },
  {
    "id": "point_defense",
    "modId": 2,
    "miniaturizationLevel": 0,
    "spacePercent": -50,
    "costPercent": -50,
    "damageMultiplier": 1,
    "hint": "Point defense: shoots incoming missiles and torpedoes, limited anti-ship output."
  },
  {
    "id": "armor_piercing",
    "modId": 3,
    "miniaturizationLevel": 1,
    "spacePercent": 50,
    "costPercent": 50,
    "damageMultiplier": 0,
    "hint": "Armor piercing: bypasses armor and hits structure directly."
  },
  {
    "id": "continuous",
    "modId": 4,
    "miniaturizationLevel": 1,
    "spacePercent": 50,
    "costPercent": 50,
    "damageMultiplier": 0,
    "hint": "Continuous: +25 to-hit bonus."
  },
  {
    "id": "no_range_dissipation",
    "modId": 5,
    "miniaturizationLevel": 1,
    "spacePercent": 25,
    "costPercent": 25,
    "damageMultiplier": 0,
    "hint": "No range dissipation: keeps full damage at all bands."
  },
  {
    "id": "shield_piercing",
    "modId": 6,
    "miniaturizationLevel": 1,
    "spacePercent": 50,
    "costPercent": 50,
    "damageMultiplier": 0,
    "hint": "Shield piercing: bypasses shields unless hard shields are active."
  },
  {
    "id": "auto_fire",
    "modId": 7,
    "miniaturizationLevel": 2,
    "spacePercent": 50,
    "costPercent": 50,
    "damageMultiplier": 0,
    "hint": "Auto-fire: fires 3 shots with lower per-shot hit chance."
  },
  {
    "id": "enveloping",
    "modId": 8,
    "miniaturizationLevel": 2,
    "spacePercent": 100,
    "costPercent": 100,
    "damageMultiplier": 0,
    "hint": "Enveloping: doubles damage and wraps around shields."
  },
  {
    "id": "mirv",
    "modId": 9,
    "miniaturizationLevel": 2,
    "spacePercent": 100,
    "costPercent": 100,
    "damageMultiplier": 0,
    "hint": "MIRV: missile splits into 4 independently interceptable warheads."
  },
  {
    "id": "eccm",
    "modId": 10,
    "miniaturizationLevel": 1,
    "spacePercent": 25,
    "costPercent": 25,
    "damageMultiplier": 0,
    "hint": "ECCM: ignores missile evasion jamming."
  },
  {
    "id": "heavily_armored",
    "modId": 11,
    "miniaturizationLevel": 1,
    "spacePercent": 25,
    "costPercent": 25,
    "damageMultiplier": 0,
    "hint": "Armored munition: survives one interceptor hit."
  },
  {
    "id": "fast",
    "modId": 12,
    "miniaturizationLevel": 1,
    "spacePercent": 25,
    "costPercent": 25,
    "damageMultiplier": 0,
    "hint": "Fast munition: higher missile or torpedo travel speed."
  },
  {
    "id": "emissions_guidance",
    "modId": 13,
    "miniaturizationLevel": 0,
    "spacePercent": 300,
    "costPercent": 300,
    "damageMultiplier": 0,
    "hint": "Emissions guidance: bypasses shields and favors drive-system knockouts."
  },
  {
    "id": "overloaded",
    "modId": 14,
    "miniaturizationLevel": 1,
    "spacePercent": 50,
    "costPercent": 50,
    "damageMultiplier": 0,
    "hint": "Overloaded: +50% damage output."
  }
] as const;

export const MOD_FLAG_KEYS: Readonly<Record<string, string>> = {
  "hv": "heavy_mount",
  "pd": "point_defense",
  "ap": "armor_piercing",
  "co": "continuous",
  "nr": "no_range_dissipation",
  "sp": "shield_piercing",
  "af": "auto_fire",
  "env": "enveloping",
  "mv": "mirv",
  "eccm": "eccm",
  "arm": "heavily_armored",
  "fst": "fast",
  "emg": "emissions_guidance",
  "ovr": "overloaded"
} as const;

export const APPLICATION_ROWS: readonly ApplicationRow[] = [
  {
    "id": "hydroponic_farm",
    "name": "Hydroponic Farm",
    "subject": "ecology",
    "fieldId": "astro_ecology",
    "techId": 86,
    "effectSummary": "An automated, sealed environment in which food can be grown, even on lifeless worlds. It increases the food output of a world by +2 food.",
    "effectSummaryLen": 137
  },
  {
    "id": "habitat_domes",
    "name": "Habitat Domes",
    "subject": "ecology",
    "fieldId": "astro_ecology",
    "techId": 27,
    "effectSummary": "Enables a colony to better control environmental conditions, allowing use of less comfortable areas of the planet. Maximum planetary population is increased by +2 million.",
    "effectSummaryLen": 171
  },
  {
    "id": "population_growth_center",
    "name": "Population Growth Center",
    "subject": "ecology",
    "fieldId": "advanced_ecology",
    "techId": 38,
    "effectSummary": "Improves colony care and family-support logistics, increasing population growth by +100K each turn as long as the current population is below the planetary maximum.",
    "effectSummaryLen": 164
  },
  {
    "id": "soil_enrichment",
    "name": "Soil Enrichment",
    "subject": "ecology",
    "fieldId": "advanced_ecology",
    "techId": 162,
    "effectSummary": "Using nano-machines, planetary soil can be molecularly enriched and fertilized, increasing the food a farmer can harvest by +1. Soil enrichment will not work in barren, energized, and hostile planets.",
    "effectSummaryLen": 200
  },
  {
    "id": "tech_detox_pods",
    "name": "Tech Detox Pods",
    "subject": "ecology",
    "fieldId": "advanced_ecology",
    "techId": 48,
    "effectSummary": "A morale-disruption payload delivered from orbit. Each launch has a 10% chance to reduce active colony population by one million. Use of morale-disruption payloads incurs a major diplomatic penalty with all other races.",
    "effectSummaryLen": 219
  },
  {
    "id": "insight_training",
    "name": "Insight Training",
    "subject": "ecology",
    "fieldId": "trait_adaptation",
    "techId": null,
    "effectSummary": "Develops advanced civic-insight methods. Enables a more effective investigative force and adds +5% to all spy rolls.",
    "effectSummaryLen": 116
  },
  {
    "id": "wellness_systems",
    "name": "Wellness Systems",
    "subject": "ecology",
    "fieldId": "trait_adaptation",
    "techId": null,
    "effectSummary": "Colony wellness support systems. Increases the population growth rate of all planets by +25% and halves the percentage chance for tech detox pods and better living cascades to reduce active population.",
    "effectSummaryLen": 201
  },
  {
    "id": "terraforming",
    "name": "Terraforming",
    "subject": "ecology",
    "fieldId": "trait_variations",
    "techId": 184,
    "effectSummary": "Makes a planet more hospitable. Barren becomes desert or tundra, deserts become arid, tundras become swamp, oceans, swamps and arid become terran. Each use on a planet increases cost by 250 production.",
    "effectSummaryLen": 201
  },
  {
    "id": "subterranean_farms",
    "name": "Subterranean Farms",
    "subject": "ecology",
    "fieldId": "macro_adaptation",
    "techId": null,
    "effectSummary": "An underground cavern system of automated farms. Increases the food output of a planet by +4.",
    "effectSummaryLen": 93
  },
  {
    "id": "weather_controller",
    "name": "Weather Controller",
    "subject": "ecology",
    "fieldId": "macro_adaptation",
    "techId": 199,
    "effectSummary": "Modifies a planet's weather patterns to create a more stable farming environment. Food production is increased by +2 per farmer.",
    "effectSummaryLen": 128
  },
  {
    "id": "civic_insight",
    "name": "Civic Insight",
    "subject": "ecology",
    "fieldId": "evolutionary_adaptation",
    "techId": null,
    "effectSummary": "Enables a powerful civic-insight network. Spying bonuses are raised by +10. Morale on all planets is increased by 10% for dictatorships and imperium government.",
    "effectSummaryLen": 160
  },
  {
    "id": "learning_optimization",
    "name": "Learning Optimization",
    "subject": "ecology",
    "fieldId": "evolutionary_adaptation",
    "techId": null,
    "effectSummary": "Through advanced education and planning, the average research capability of the empire is substantially improved, increasing the research of all scientists by +1.",
    "effectSummaryLen": 162
  },
  {
    "id": "better_living_cascade",
    "name": "Better Living Cascade",
    "subject": "ecology",
    "fieldId": "synthetic_ecosystems",
    "techId": 28,
    "effectSummary": "An advanced morale-disruption cascade with a 20% chance to reduce active colony population by one million. Use of morale-disruption payloads incurs a major diplomatic penalty with all other races.",
    "effectSummaryLen": 196
  },
  {
    "id": "universal_wellness_protocol",
    "name": "Universal Wellness Protocol",
    "subject": "ecology",
    "fieldId": "synthetic_ecosystems",
    "techId": null,
    "effectSummary": "Increases the population growth rate of all colonies by +50% and quarters the chance for tech detox pods and better living cascades to reduce active population. Not cumulative with wellness systems.",
    "effectSummaryLen": 198
  },
  {
    "id": "adaptive_habitat_lattice",
    "name": "Adaptive Habitat Lattice",
    "subject": "ecology",
    "fieldId": "trans_adaptation",
    "techId": 29,
    "effectSummary": "Hardy food systems that operate anywhere, increasing the food output of all planets by +1 food per farmer, including worlds with 0 food output.",
    "effectSummaryLen": 143
  },
  {
    "id": "gaia_transformation",
    "name": "Habitat Transformation",
    "subject": "ecology",
    "fieldId": "trans_adaptation",
    "techId": 211,
    "effectSummary": "Creates a broad, stable habitat by introducing adaptive ecology systems into the world. Can only be applied to terran environments.",
    "effectSummaryLen": 131
  },
  {
    "id": "trait_reassignment",
    "name": "Trait Reassignment",
    "subject": "ecology",
    "fieldId": "trans_adaptation",
    "techId": null,
    "effectSummary": "Allows you to reassign race traits, altering their abilities. When trait reassignment is researched, you may choose 4 additional points of race development picks, to either remove disadvantages or increase advantages.",
    "effectSummaryLen": 217
  },
  {
    "id": "nuclear_missile",
    "name": "Nuclear Missile",
    "subject": "chemistry",
    "fieldId": "chemistry",
    "techId": 121,
    "effectSummary": "Carries a high-yield nuclear warhead that inflicts 8 points of damage. Modifications: MIRV, emissions guildance, fast, heavily armored and ECCM.",
    "effectSummaryLen": 144
  },
  {
    "id": "standard_fuel_cells",
    "name": "Standard Fuel Cells",
    "subject": "chemistry",
    "fieldId": "chemistry",
    "techId": null,
    "effectSummary": "Supplies sufficient energy to propel a ship 4 parsecs before refueling.",
    "effectSummaryLen": 71
  },
  {
    "id": "extended_fuel_tanks",
    "name": "Extended Fuel Tanks",
    "subject": "chemistry",
    "fieldId": "chemistry",
    "techId": null,
    "effectSummary": "Increases the overall range of a ship by +50%, but at the cost of considerable amount of space.",
    "effectSummaryLen": 95
  },
  {
    "id": "titanium_armor",
    "name": "Titanium Armor",
    "subject": "chemistry",
    "fieldId": "chemistry",
    "techId": null,
    "effectSummary": "The standard armor of ships.",
    "effectSummaryLen": 28
  },
  {
    "id": "deuterium_fuel_cells",
    "name": "Deuterium Fuel Cells",
    "subject": "chemistry",
    "fieldId": "advanced_metallurgy",
    "techId": 49,
    "effectSummary": "Supplies sufficient energy to propel a ship up to 6 parsecs before refueling.",
    "effectSummaryLen": 77
  },
  {
    "id": "tritanium_armor",
    "name": "Tritanium Armor",
    "subject": "chemistry",
    "fieldId": "advanced_metallurgy",
    "techId": 189,
    "effectSummary": "Ships with this armor have twice the base structure and armor points. The hit points of fighters are multiplied by 1.5. Adds +10 to ground troop combat strengths.",
    "effectSummaryLen": 162
  },
  {
    "id": "merculite_missiles",
    "name": "Merculite Missile",
    "subject": "chemistry",
    "fieldId": "advanced_chemistry",
    "techId": 106,
    "effectSummary": "Carries a powerful chemically-based explosive warhead capable of delivering 14 points of damage. Modifications: MIRV, emissions guidance, fast, armored, and ECCM.",
    "effectSummaryLen": 162
  },
  {
    "id": "pollution_processor",
    "name": "Pollution Processor",
    "subject": "chemistry",
    "fieldId": "advanced_chemistry",
    "techId": 141,
    "effectSummary": "Uses advanced chemicals to process factory waste. Only half of the actual production of the planet used to calculate pollution.",
    "effectSummaryLen": 127
  },
  {
    "id": "pulson_missiles",
    "name": "Pulson Missile",
    "subject": "chemistry",
    "fieldId": "molecular_compression",
    "techId": 149,
    "effectSummary": "Carries a powerful high-energy pulse capable of delivering 20 points of damage. Modifications: MIRV, emissions guidance, fast, armored, and ECCM.",
    "effectSummaryLen": 145
  },
  {
    "id": "atmospheric_renewer",
    "name": "Atmospheric Renewer",
    "subject": "chemistry",
    "fieldId": "molecular_compression",
    "techId": 21,
    "effectSummary": "Eliminates many dangerous particles from the atmosphere of a planet. The amount of production is quartered before calculating pollution. Effects are cumulative with a pollution processor.",
    "effectSummaryLen": 187
  },
  {
    "id": "iridium_fuel_cells",
    "name": "Iridium Fuel Cells",
    "subject": "chemistry",
    "fieldId": "molecular_compression",
    "techId": 93,
    "effectSummary": "Supplies sufficient energy to propel a ship 9 parsecs before refueling.",
    "effectSummaryLen": 71
  },
  {
    "id": "nano_disassemblers",
    "name": "Nano Disassemblers",
    "subject": "chemistry",
    "fieldId": "nano_technology",
    "techId": 116,
    "effectSummary": "Microscopic nano-machines capable of breaking down environmental contaminants. Doubles the number of production units a planet can produce before any pollution is created.",
    "effectSummaryLen": 171
  },
  {
    "id": "microlite_construction",
    "name": "Microlite Construction",
    "subject": "chemistry",
    "fieldId": "nano_technology",
    "techId": 108,
    "effectSummary": "Using microscopic nano-machines to construct buildings and ships with less metal, but with the same strength and durability. Increases productivity of all workers by +1 production.",
    "effectSummaryLen": 180
  },
  {
    "id": "zortrium_armor",
    "name": "Zortrium Armor",
    "subject": "chemistry",
    "fieldId": "nano_technology",
    "techId": null,
    "effectSummary": "Ships with this armor have 5 times the base structure and armor points. The hit points of fighters are multiplied by 2. Adds +15 to ground troop combat strengths.",
    "effectSummaryLen": 162
  },
  {
    "id": "zeon_missile",
    "name": "Zeon Missile",
    "subject": "chemistry",
    "fieldId": "molecular_manipulation",
    "techId": 202,
    "effectSummary": "Carries a powerful explosive warhead capable of delivering 30 points of damage. Modifications: MIRV, emissions guidance, fast traveling, armored and ECCM.",
    "effectSummaryLen": 154
  },
  {
    "id": "neutronium_armor",
    "name": "Neutronium Armor",
    "subject": "chemistry",
    "fieldId": "molecular_manipulation",
    "techId": 60,
    "effectSummary": "Ships with this armor have 6 times the base structure and armor points. The hit points of fighters are multiplied by 5. Adds +20 to ground troop combat strengths.",
    "effectSummaryLen": 162
  },
  {
    "id": "uridium_fuel_cells",
    "name": "Uridium Fuel Cells",
    "subject": "chemistry",
    "fieldId": "molecular_manipulation",
    "techId": 193,
    "effectSummary": "Supply sufficent energy to propel a ship 12 parsecs before refueling.",
    "effectSummaryLen": 69
  },
  {
    "id": "thorium_fuel_cells",
    "name": "Thorium Fuel Cells",
    "subject": "chemistry",
    "fieldId": "molecular_control",
    "techId": 185,
    "effectSummary": "Advanced fuel system that self-regenerates, providing all ships with an unlimited fuel supply and range.",
    "effectSummaryLen": 104
  },
  {
    "id": "adamantium_armor",
    "name": "Adamantium Armor",
    "subject": "chemistry",
    "fieldId": "molecular_control",
    "techId": null,
    "effectSummary": "Ships with this armor have 8 times the base structure and armor points. The hit points of fighters are multiplied by 4. Adds +25 to ground troop combat strengths.",
    "effectSummaryLen": 162
  },
  {
    "id": "electronic_computer",
    "name": "Electronic Computer",
    "subject": "computers",
    "fieldId": "electronics",
    "techId": 56,
    "effectSummary": "Directs starship weapons' fire and is automatically equipped on all ships, increasing chance to hit by +25%. This bonus is lost if the computer is damaged or destroyed.",
    "effectSummaryLen": 168
  },
  {
    "id": "research_lab",
    "name": "Research Laboratory",
    "subject": "computers",
    "fieldId": "optronics",
    "techId": 152,
    "effectSummary": "Houses state-of-the-art computer equipment, creating a superior research environment. Generates 5 research points and increases the research each scientist produces by +1.",
    "effectSummaryLen": 171
  },
  {
    "id": "optronic_computer",
    "name": "Optronic Computer",
    "subject": "computers",
    "fieldId": "optronics",
    "techId": null,
    "effectSummary": "Directs all starship weapons fire, adding +50 to the chance to hit. Bonus is lost if computer is destroyed.",
    "effectSummaryLen": 107
  },
  {
    "id": "dauntless_guidance_system",
    "name": "Dauntless Guidance System",
    "subject": "computers",
    "fieldId": "optronics",
    "techId": null,
    "effectSummary": "Provides friend-or-foe recognition guidance to missiles and torpedoes. They will retarget the nearest enemy ship if their target is destroyed.",
    "effectSummaryLen": 142
  },
  {
    "id": "neural_scanner",
    "name": "Neural Scanner",
    "subject": "computers",
    "fieldId": "artificial_intelligence",
    "techId": null,
    "effectSummary": "With improved data processing methods, the pathways of the brain can be mapped and analyzed. Provides a near perfect lie detector used by spies to elicit information, adding +10 to all spy rolls.",
    "effectSummaryLen": 195
  },
  {
    "id": "scout_lab",
    "name": "Scout Lab",
    "subject": "computers",
    "fieldId": "artificial_intelligence",
    "techId": 156,
    "effectSummary": "A computer assisted laboratory that generates an amount of research dependent on the ship size: 1, 2, 4, 8, 16, or 32. Also adds +10 per size class to the attack roll of all ships in a fleet fighting space monsters or Antarans.",
    "effectSummaryLen": 227
  },
  {
    "id": "security_stations",
    "name": "Security Stations",
    "subject": "computers",
    "fieldId": "artificial_intelligence",
    "techId": null,
    "effectSummary": "Automatically controls and monitors vital sections of ship, attacking intruders with computer-controlled weapons. Adds +20 to the combat rolls of marines when defending against enemy boarders.",
    "effectSummaryLen": 192
  },
  {
    "id": "positronic_computer",
    "name": "Positronic Computer",
    "subject": "computers",
    "fieldId": "positronics",
    "techId": 142,
    "effectSummary": "Directs all ship beam weapons fire, adding +75% chance to hit. If the computer is damaged or destroyed, the ship loses the attack bonus.",
    "effectSummaryLen": 136
  },
  {
    "id": "supercomputer",
    "name": "Planetary Supercomputer",
    "subject": "computers",
    "fieldId": "positronics",
    "techId": 178,
    "effectSummary": "Supplies researchers with a vast amount of information. Generates 10 research points and increases the research each scientist produces by +2.",
    "effectSummaryLen": 142
  },
  {
    "id": "holo_simulator",
    "name": "Holo Simulator",
    "subject": "computers",
    "fieldId": "positronics",
    "techId": 84,
    "effectSummary": "Capable of creating realistic 3-D images from holographic projections. Increases a planet's morale by +20%.",
    "effectSummaryLen": 107
  },
  {
    "id": "emissions_guidance_system",
    "name": "Emissions Guidance System",
    "subject": "computers",
    "fieldId": "artificial_consciousness",
    "techId": 57,
    "effectSummary": "Tracks the warp signatures of a vehicle. If the missile penetrates the shields, all damage is applied to the ship's drive, bypassing any armor. Requires 4 times the space and cost 4 times more than regular missiles.",
    "effectSummaryLen": 215
  },
  {
    "id": "rangemaster_target_unit",
    "name": "Rangemaster Target Unit",
    "subject": "computers",
    "fieldId": "artificial_consciousness",
    "techId": null,
    "effectSummary": "Corrects for long-range targeting inaccuracies, the actual range is divided by three for purposes of to-hit bonuses only.",
    "effectSummaryLen": 121
  },
  {
    "id": "cyber_security_link",
    "name": "Cyber Security Link",
    "subject": "computers",
    "fieldId": "artificial_consciousness",
    "techId": 43,
    "effectSummary": "Provides a direct mental link to computers, allowing spies to circumvent many automated security systems. Adds +10 to all spy rolls.",
    "effectSummaryLen": 132
  },
  {
    "id": "cybertronic_computer",
    "name": "Cybertronic Computer",
    "subject": "computers",
    "fieldId": "cybertronics",
    "techId": 44,
    "effectSummary": "Learns and adapts using a neural net similar to the adaptive processor. Equipped on all ships, it adds +100% chance to hit with beam weapons. Attack bonuses are eliminated if the computer is damaged or destroyed.",
    "effectSummaryLen": 212
  },
  {
    "id": "autolab",
    "name": "Autolab",
    "subject": "computers",
    "fieldId": "cybertronics",
    "techId": 19,
    "effectSummary": "A completely automated research facility. Generates 30 research points.",
    "effectSummaryLen": 71
  },
  {
    "id": "structural_analyzer",
    "name": "Structural Analyzer",
    "subject": "computers",
    "fieldId": "cybertronics",
    "techId": 181,
    "effectSummary": "Links to ship's weapons array to more accurately choose target's weak armor points. All damage that penetrates the target's shields is doubled.",
    "effectSummaryLen": 143
  },
  {
    "id": "android_farmers",
    "name": "Android Farmers",
    "subject": "computers",
    "fieldId": "cybertechnics",
    "techId": 9,
    "effectSummary": "Mechanical workers with a +3 food production bonus. Require 1 production unit per turn instead of food. They are unaffected by morale, receive no racial bonuses, and generate no income.",
    "effectSummaryLen": 185
  },
  {
    "id": "android_workers",
    "name": "Android Workers",
    "subject": "computers",
    "fieldId": "cybertechnics",
    "techId": 11,
    "effectSummary": "Mechanical workers with a +3 production bonus. Require 1 production unit per turn instead of food. They are unaffected by morale, receive no racial bonuses, and generate no income.",
    "effectSummaryLen": 180
  },
  {
    "id": "android_scientists",
    "name": "Android Scientists",
    "subject": "computers",
    "fieldId": "cybertechnics",
    "techId": 10,
    "effectSummary": "Mechanical workers that generate 3 research points per turn. Require 1 production unit per turn instead of food. They are unaffected by morale, receive no racial bonuses, and generate no income.",
    "effectSummaryLen": 194
  },
  {
    "id": "virtual_reality_network",
    "name": "Virtual Reality Network",
    "subject": "computers",
    "fieldId": "galactic_networking",
    "techId": 196,
    "effectSummary": "Creates a galaxy wide cyberspace connection which individuals can tap into to experience alternate realities. Increases morale +20% throughout your entire empire.",
    "effectSummaryLen": 162
  },
  {
    "id": "galactic_cybernet",
    "name": "Galactic Cybernet",
    "subject": "computers",
    "fieldId": "galactic_networking",
    "techId": null,
    "effectSummary": "Nearly instantaneous galaxy-wide communications, allowing quick exchange of information and ideas. The cybernet generates 15 research points and each scientist generates +3 research each.",
    "effectSummaryLen": 187
  },
  {
    "id": "pleasure_dome",
    "name": "Pleasure Dome",
    "subject": "computers",
    "fieldId": "moleculartronics",
    "techId": null,
    "effectSummary": "The ultimate in virtual holographic entertainment, creating completely immersive entertainment environments. It increases morale by +30% and is cumulative with holo simulator.",
    "effectSummaryLen": 175
  },
  {
    "id": "moleculartronic_computer",
    "name": "Moleculartronic Computer",
    "subject": "computers",
    "fieldId": "moleculartronics",
    "techId": null,
    "effectSummary": "Directs all starship weapon fire, adding +125% to the chance to hit. If the computer is destroyed, the ship loses the bonus.",
    "effectSummaryLen": 124
  },
  {
    "id": "achilles_targeting_unit",
    "name": "Achilles Targeting Unit",
    "subject": "computers",
    "fieldId": "moleculartronics",
    "techId": 15,
    "effectSummary": "Triples the chance of striking an enemy's weapon and shield systems and completely bypasses the target's armor.",
    "effectSummaryLen": 111
  },
  {
    "id": "colony_base",
    "name": "Colony Base",
    "subject": "construction",
    "fieldId": "engineering",
    "techId": 39,
    "effectSummary": "Creates a colony on another planet inside the sme star system as the building colony.",
    "effectSummaryLen": 85
  },
  {
    "id": "star_base",
    "name": "Star Base",
    "subject": "construction",
    "fieldId": "engineering",
    "techId": 167,
    "effectSummary": "Armed orbital platforms used to service military ships. They are equipped with extensive weaponry, the best available scanner with a =2 scanning range bonus and a star dock capable of building ships larger than destroyers.",
    "effectSummaryLen": 222
  },
  {
    "id": "marine_barracks",
    "name": "Marine Barracks",
    "subject": "construction",
    "fieldId": "engineering",
    "techId": 107,
    "effectSummary": "Lets the colony train troops for ground invasion protection. Begins with 4 marine units, then trains 1 unit every 5 turns, up to the planet's maximum population. Eliminates morale penalties for dictatorships and feudal governments.",
    "effectSummaryLen": 231
  },
  {
    "id": "anti_missile_rocket",
    "name": "Anti-Missile Rockets",
    "subject": "construction",
    "fieldId": "advanced_engineering",
    "techId": 13,
    "effectSummary": "Can only target missiles. They have a maximum range of 15 squares and will fire defensively against approaching missiles if not yet fired in that turn. The chance to score a hit is 85% minus 5% per square distance.",
    "effectSummaryLen": 214
  },
  {
    "id": "fighter_bays",
    "name": "Fighter Bays",
    "subject": "construction",
    "fieldId": "advanced_engineering",
    "techId": 59,
    "effectSummary": "Allows a ship to carry a group of 4 short-range fighters. They carry one beam weapon of the best type that can have the point defense modification, and can fire it 4 times before returning to the launching ship.",
    "effectSummaryLen": 211
  },
  {
    "id": "reinforced_hull",
    "name": "Reinforced Hull",
    "subject": "construction",
    "fieldId": "advanced_engineering",
    "techId": 151,
    "effectSummary": "Triples the structural integrity of a ship and provides more protection for the ship's drive system, tripling the amount of damage required to destroy it.",
    "effectSummaryLen": 154
  },
  {
    "id": "automated_factory",
    "name": "Automated Factories",
    "subject": "construction",
    "fieldId": "advanced_construction",
    "techId": 20,
    "effectSummary": "Aid industry workers in their building of finished products. Generates 5 production and increases the production each worker generates by +1.",
    "effectSummaryLen": 141
  },
  {
    "id": "missile_base",
    "name": "Missile Base",
    "subject": "construction",
    "fieldId": "advanced_construction",
    "techId": 109,
    "effectSummary": "Contains 300 space units of your best missiles, with unlimited ammo.",
    "effectSummaryLen": 68
  },
  {
    "id": "heavy_armor",
    "name": "Heavy Armor",
    "subject": "construction",
    "fieldId": "advanced_construction",
    "techId": null,
    "effectSummary": "Heavy armor negates armor piercing effects and reinforces the armor of a ship, tripling the amount of damage the armor can absorb.",
    "effectSummaryLen": 130
  },
  {
    "id": "battle_pods",
    "name": "Battle Pods",
    "subject": "construction",
    "fieldId": "capsule_construction",
    "techId": 22,
    "effectSummary": "Battle Pods increase the available space on a ship by 50%.",
    "effectSummaryLen": 58
  },
  {
    "id": "troop_pods",
    "name": "Troop Pods",
    "subject": "construction",
    "fieldId": "capsule_construction",
    "techId": null,
    "effectSummary": "Troop pods house additional detachments of space marines, doubling the number of marines on board a ship. The additional marines can defend the ship or board enemy ships.",
    "effectSummaryLen": 170
  },
  {
    "id": "survival_pods",
    "name": "Survival Pods",
    "subject": "construction",
    "fieldId": "capsule_construction",
    "techId": null,
    "effectSummary": "Provides suspended animation facilities for legendary officers if their ship is destroyed. At least one friendly ship must survive the combat to rescue any surviving officers.",
    "effectSummaryLen": 175
  },
  {
    "id": "space_port",
    "name": "Space Port",
    "subject": "construction",
    "fieldId": "astro_engineering",
    "techId": 163,
    "effectSummary": "Site for commercial transactions, increasing the money generation of a colony by +50%.",
    "effectSummaryLen": 86
  },
  {
    "id": "armor_barracks",
    "name": "Armor Barracks",
    "subject": "construction",
    "fieldId": "astro_engineering",
    "techId": null,
    "effectSummary": "Creates tank battalions. It has 2 units when built, and adds 1 unit every 10 turns, up to half the planet's population. Eliminates the morale penalty for dictatorships and feudal governments.",
    "effectSummaryLen": 191
  },
  {
    "id": "fighter_garrison",
    "name": "Fighter Garrison",
    "subject": "construction",
    "fieldId": "astro_engineering",
    "techId": 61,
    "effectSummary": "Planetary base that houses 10-interceptors. Fighter Garrisons are equipped with 6-bomber, or 4-heavy fighter squadrons when the appropriate technology becomes available. New fighters become available every 10 combat turns.",
    "effectSummaryLen": 222
  },
  {
    "id": "robominers",
    "name": "Robo Mining Plant",
    "subject": "construction",
    "fieldId": "robotics",
    "techId": 155,
    "effectSummary": "Automate many difficult tasks, increasing the productivity of industrial workers. Generates 10 production and increases the production each worker produces by +2.",
    "effectSummaryLen": 162
  },
  {
    "id": "battlestation",
    "name": "Battle Station",
    "subject": "construction",
    "fieldId": "robotics",
    "techId": 23,
    "effectSummary": "Heavily armed star base, with +4 parsec scanning range bonus. Adds +10% to the offense of ships in combat around it. Replaces a star base.",
    "effectSummaryLen": 138
  },
  {
    "id": "powered_armor",
    "name": "Powered Armor",
    "subject": "construction",
    "fieldId": "robotics",
    "techId": null,
    "effectSummary": "Provides troops with superior power and mobility by mechanically magnifying their natural strength. Powered armor equipped troops have a +10 bonus to their combat rating and take +1 additional hit to disable.",
    "effectSummaryLen": 208
  },
  {
    "id": "fast_missile_racks",
    "name": "Fast Missile Racks",
    "subject": "construction",
    "fieldId": "servo_mechanics",
    "techId": 58,
    "effectSummary": "Allows a ship to fire two volleys of missiles in one turn. Will only fire one per turn, after that unless the ship takes one full turn without firing missiles to reload.",
    "effectSummaryLen": 169
  },
  {
    "id": "advanced_damage_control",
    "name": "Advanced Damage Control",
    "subject": "construction",
    "fieldId": "servo_mechanics",
    "techId": null,
    "effectSummary": "Completely repairs ships between battles. Automatically included in all ships once the technology is researched.",
    "effectSummaryLen": 112
  },
  {
    "id": "assault_shuttle",
    "name": "Assault Shuttles",
    "subject": "construction",
    "fieldId": "servo_mechanics",
    "techId": 17,
    "effectSummary": "Squadron of 4 shuttles used to move 1 unit of marines each from the launching ship onto enemy ships. They take 3 hits to destroy, modified by your best armor, and move at a speed of 6.",
    "effectSummaryLen": 184
  },
  {
    "id": "titan_construction",
    "name": "Titan Construction",
    "subject": "construction",
    "fieldId": "astro_construction",
    "techId": 186,
    "effectSummary": "The titan class of starship is gigantic in proportion to other ships, and requires advanced engineering techniques to both construct and integrate ship systems.",
    "effectSummaryLen": 160
  },
  {
    "id": "ground_batteries",
    "name": "Ground Batteries",
    "subject": "construction",
    "fieldId": "astro_construction",
    "techId": 81,
    "effectSummary": "Ground installation that contains 300 space units of heawy mount and point defense versions of the best available beam weapons.",
    "effectSummaryLen": 127
  },
  {
    "id": "battleoids",
    "name": "Battleoids",
    "subject": "construction",
    "fieldId": "astro_construction",
    "techId": 224,
    "effectSummary": "Giant robot fighting vehicles superior in power and mobility to conventional tanks. They have a +10 bonus to their combat rating and take 3 hits to destroy.",
    "effectSummaryLen": 156
  },
  {
    "id": "recyclotron",
    "name": "Recyclotron",
    "subject": "construction",
    "fieldId": "advanced_manufacturing",
    "techId": null,
    "effectSummary": "Allows scrap material reuse, reducing construction costs. Every unit of population generates +1 production. This increase does not count toward planetary pollution level.",
    "effectSummaryLen": 170
  },
  {
    "id": "automated_repair_unit",
    "name": "Automated Repair Unit",
    "subject": "construction",
    "fieldId": "advanced_manufacturing",
    "techId": null,
    "effectSummary": "Repairs a ship during combat, restoring 20% of the armor or structure and 10% of the ship's internal systems each turn during combat. After combat, the ship is completely repaired.",
    "effectSummaryLen": 180
  },
  {
    "id": "artificial_planet_construction",
    "name": "Artificial Planet Construction",
    "subject": "construction",
    "fieldId": "advanced_manufacturing",
    "techId": 16,
    "effectSummary": "A colony that has an asteroid field or gas giant within its star system can create a complete artificial planet capable of supporting life.",
    "effectSummaryLen": 139
  },
  {
    "id": "robotic_factory",
    "name": "Robotic Factory",
    "subject": "construction",
    "fieldId": "advanced_robotics",
    "techId": null,
    "effectSummary": "Builds mechanical workers that add production dependent on a colony's mineral resources 5, 8, 10, 15 or 20.",
    "effectSummaryLen": 107
  },
  {
    "id": "bomber_bays",
    "name": "Bomber Bays",
    "subject": "construction",
    "fieldId": "advanced_robotics",
    "techId": 31,
    "effectSummary": "Short range ships carrying a bomb that can be dropped on a planet or detonated on a ship. They carry one bomb each of the best type available. They move in groups of 4 at a speed of 10",
    "effectSummaryLen": 184
  },
  {
    "id": "deep_core_mine",
    "name": "Deep Core Mine",
    "subject": "construction",
    "fieldId": "tectonic_engineering",
    "techId": 45,
    "effectSummary": "Allows miners to build stable tunnels into a planet. Generates 15 production annd increases the productivity of each worker by +3 production each.",
    "effectSummaryLen": 146
  },
  {
    "id": "core_waste_dump",
    "name": "Core Waste Dumps",
    "subject": "construction",
    "fieldId": "tectonic_engineering",
    "techId": null,
    "effectSummary": "Take man-made industrial byproducts and store them deep within the surface of a planet, far below water supplies. Planetary pollution is completely eliminated.",
    "effectSummaryLen": 159
  },
  {
    "id": "star_fortress",
    "name": "Star Fortress",
    "subject": "construction",
    "fieldId": "superscalar_construction",
    "techId": 169,
    "effectSummary": "A large military orbital platform. Has a +6 parsec scan range bonus and adds +20% to both the offense and defense of all ships in combat around it. Replaces battlestations and star bases.",
    "effectSummaryLen": 187
  },
  {
    "id": "advanced_city_planning",
    "name": "Advanced City Planning",
    "subject": "construction",
    "fieldId": "superscalar_construction",
    "techId": null,
    "effectSummary": "Pre-planned, organized colony design techniques in organization increase the maximum population that can live on all planets owned by the empire by +5 million.",
    "effectSummaryLen": 159
  },
  {
    "id": "heavy_fighter_bays",
    "name": "Heavy Fighters",
    "subject": "construction",
    "fieldId": "superscalar_construction",
    "techId": 83,
    "effectSummary": "Allow ships to carry heavy fighters equipped with 2 of the best point defense beam weapon and 2 of the best bomb available. They have 5 hits, modified by yours best armor, and move at speed 12.",
    "effectSummaryLen": 193
  },
  {
    "id": "doom_star_construction",
    "name": "Doom Star Construction",
    "subject": "construction",
    "fieldId": "planetoid_construction",
    "techId": 50,
    "effectSummary": "Mobile planetoid bases. They are the largest ships that can be built.",
    "effectSummaryLen": 69
  },
  {
    "id": "artemis_system_net",
    "name": "Artemis System Net",
    "subject": "construction",
    "fieldId": "planetoid_construction",
    "techId": null,
    "effectSummary": "Network of mines. Ships have a chance of damage based on size: frigate-20%, destroyer-30%, cruiser-40%, battleship-50%, titan-80%, doomstar-100%. Damage is 100-500 points less shields.",
    "effectSummaryLen": 184
  },
  {
    "id": "class_i_shield",
    "name": "Class I Shield",
    "subject": "force_fields",
    "fieldId": "advanced_magnetism",
    "techId": 25,
    "effectSummary": "Protects ships from physical and energy attacks. Absorbs up to 5 times the ship's size in damage before failing, with each attack reduced by 1 points of damage. Regenerates 30% per combat turn.",
    "effectSummaryLen": 193
  },
  {
    "id": "mass_driver",
    "name": "Mass Driver",
    "subject": "force_fields",
    "fieldId": "advanced_magnetism",
    "techId": 104,
    "effectSummary": "A rail gun firing a hyper-velocity projectile. Inflicts 6 points of damage. Damage is not reduced by range. Modifications: autofire, armor piercing, heavy mount, point defense.",
    "effectSummaryLen": 176
  },
  {
    "id": "ecm_jammer",
    "name": "ECM Jammer",
    "subject": "force_fields",
    "fieldId": "advanced_magnetism",
    "techId": null,
    "effectSummary": "Creates a magnetic pulse jamming both weapon tracking systems and missile guidance units, adding +70% to the ship's missile evasion.",
    "effectSummaryLen": 132
  },
  {
    "id": "anti_grav_harness",
    "name": "Anti-Grav Harness",
    "subject": "force_fields",
    "fieldId": "gravitic_fields",
    "techId": 14,
    "effectSummary": "Allows ground troops and armor to fly, increasing their mobility and defense. Adds +10 to their ground combat rating.",
    "effectSummaryLen": 117
  },
  {
    "id": "inertial_stabilizer",
    "name": "Inertial Stabilizer",
    "subject": "force_fields",
    "fieldId": "gravitic_fields",
    "techId": 90,
    "effectSummary": "Creates a partial warp field that can operate in normal space. It vastly improves the ship's mobility and makes it considerably harder to target, adding +50 to ship's beam defense and halving movement cost for turning.",
    "effectSummaryLen": 218
  },
  {
    "id": "gyro_destabilizer",
    "name": "Gyro Destabilizer",
    "subject": "force_fields",
    "fieldId": "gravitic_fields",
    "techId": 80,
    "effectSummary": "Creates a sudden rift in a ship's subspace field. Weakens the inertial controls of the ship, spinning it in random directions, inflicting 1-4 points of structural damage times the ship's size class. Range is 15 squares.",
    "effectSummaryLen": 219
  },
  {
    "id": "class_iii_shield",
    "name": "Class III Shield",
    "subject": "force_fields",
    "fieldId": "magneto_gravitics",
    "techId": 26,
    "effectSummary": "Protects ships from physical and energy attacks. Absorbs up to 15 times the ship's size in damage before failing, with each attack reduced by 3 points of damage. Regenerates 30% per combat turn.",
    "effectSummaryLen": 194
  },
  {
    "id": "stellar_safety_shield",
    "name": "Stellar Safety Shield",
    "subject": "force_fields",
    "fieldId": "magneto_gravitics",
    "techId": 150,
    "effectSummary": "Reduces solar and cosmic environmental stress so colonies can operate comfortably on the surface. Energized climates become Barren. Reduces damage against a planet by 5 points.",
    "effectSummaryLen": 176
  },
  {
    "id": "warp_dissipater",
    "name": "Warp Dissipator",
    "subject": "force_fields",
    "fieldId": "magneto_gravitics",
    "techId": 197,
    "effectSummary": "Creates a large radius field about a ship that prevents any ship from enter into hyperspace. Enemy ships cannon retreat while the dissipator is functioning.",
    "effectSummaryLen": 156
  },
  {
    "id": "stealth_field",
    "name": "Stealth Field",
    "subject": "force_fields",
    "fieldId": "electromagnetic_refraction",
    "techId": 170,
    "effectSummary": "Reduces the gravitic emissions from FTL drives. Ships equipped with stealth fields can not be detected at any range on the main screen.",
    "effectSummaryLen": 135
  },
  {
    "id": "personal_shield",
    "name": "Personal Shield",
    "subject": "force_fields",
    "fieldId": "electromagnetic_refraction",
    "techId": 126,
    "effectSummary": "Deflects physical and energy attacks, increasing the combat rating of militia, troops and armor by +20.",
    "effectSummaryLen": 103
  },
  {
    "id": "stealth_suit",
    "name": "Stealth Suit",
    "subject": "force_fields",
    "fieldId": "electromagnetic_refraction",
    "techId": null,
    "effectSummary": "Renders a person virtually invisible, blending the wearer into the background. Adds +10 to all spy rolls.",
    "effectSummaryLen": 105
  },
  {
    "id": "pulsar",
    "name": "Pulsar",
    "subject": "force_fields",
    "fieldId": "warp_fields",
    "techId": 148,
    "effectSummary": "When fired, causes violent vibrations in ships, missiles and fighters adjacent to the equipped ships. Inflicts 2-24 points of damage per size class of the ship damaged.",
    "effectSummaryLen": 168
  },
  {
    "id": "warp_interdictor",
    "name": "Warp Field Interdicter",
    "subject": "force_fields",
    "fieldId": "warp_fields",
    "techId": 198,
    "effectSummary": "Creates a warp destabilizing field around the star system in which it is built. Generates a field 2 parsecs in radius about the system that slows all enemy movement to 1 parsec per turn.",
    "effectSummaryLen": 186
  },
  {
    "id": "lightning_field",
    "name": "Lightning Field",
    "subject": "force_fields",
    "fieldId": "warp_fields",
    "techId": 102,
    "effectSummary": "Surrounds a ship in a powerful energized field capable of overloading the targeting system of any missile, torpedo or fighter. Has a 50% chance of destroying these weapons before they damage the ship.",
    "effectSummaryLen": 200
  },
  {
    "id": "class_v_shield",
    "name": "Class V Shield",
    "subject": "force_fields",
    "fieldId": "subspace_fields",
    "techId": 35,
    "effectSummary": "Protects ships from physical and energy attacks. Absorbs up to 25 times the ship's size in damage before failing, with each attack reduced by 5 points of damage. Regenerates 30% per combat turn.",
    "effectSummaryLen": 194
  },
  {
    "id": "multi_wave_ecm_jammer",
    "name": "Multi-Wave ECM Jammer",
    "subject": "force_fields",
    "fieldId": "subspace_fields",
    "techId": 111,
    "effectSummary": "Jamming frequencies across the entire spectrum this device adds +100 to the ships missile evasion rating.",
    "effectSummaryLen": 105
  },
  {
    "id": "gauss_cannon",
    "name": "Gauss Cannon",
    "subject": "force_fields",
    "fieldId": "subspace_fields",
    "techId": 78,
    "effectSummary": "An extremely powerful linear accelerator which inflicts 18 points of damage regardless of range. Modifications: autofire, armor piercing, heavy mount.",
    "effectSummaryLen": 150
  },
  {
    "id": "cloaking_device",
    "name": "Cloaking Device",
    "subject": "force_fields",
    "fieldId": "distortion_fields",
    "techId": null,
    "effectSummary": "Completely hides a ship from long range scans. In combat, it adds +80 to the ship's beam defense and missiles have a 50% chance to miss as long as the ship does not attack. Must wait one turn without firing to recloak.",
    "effectSummaryLen": 218
  },
  {
    "id": "stasis_field",
    "name": "Stasis Field",
    "subject": "force_fields",
    "fieldId": "distortion_fields",
    "techId": 171,
    "effectSummary": "Places target in suspended animation. It cannot fire, recharge weapons, cloak or be attacked. Field has a 3-square range and will hold the target ship until the stasis field is turned off or destroyed.",
    "effectSummaryLen": 201
  },
  {
    "id": "hard_shields",
    "name": "Hard Shields",
    "subject": "force_fields",
    "fieldId": "distortion_fields",
    "techId": 82,
    "effectSummary": "Reduces the damage of any attack by an additional 3 points. Allows operation of all shields in a nebula and prevents the use of enemy tranporters even after shields have been dropped. Immune to shield-piercing weapons.",
    "effectSummaryLen": 218
  },
  {
    "id": "class_vii_shield",
    "name": "Class VII Shield",
    "subject": "force_fields",
    "fieldId": "quantum_fields",
    "techId": 36,
    "effectSummary": "Protects ships from physical and energy attacks. Absorbs up to 35 times the ship's size in damage before failing, with each attack reduced by 7 points of damage. Regenerates 30% per combat turn.",
    "effectSummaryLen": 194
  },
  {
    "id": "planetary_flux_shield",
    "name": "Planetary Flux Shield",
    "subject": "force_fields",
    "fieldId": "quantum_fields",
    "techId": 130,
    "effectSummary": "Seals planet in an energy field. Converts Energized climates into Barren. Reduces damage against the planet 10 points. It replaces any stellar safety shield already built.",
    "effectSummaryLen": 171
  },
  {
    "id": "wide_area_jammer",
    "name": "Wide Area Jammer",
    "subject": "force_fields",
    "fieldId": "quantum_fields",
    "techId": 200,
    "effectSummary": "Adds +130 to a ship's missile evasion rating, adds +70 to the missile evasion of other ships in the fleet. The fleet's bonus is not cumulative with any missile evasion bonus given by other jammers. Only the best bonus will apply.",
    "effectSummaryLen": 229
  },
  {
    "id": "displacement_device",
    "name": "Displacement Device",
    "subject": "force_fields",
    "fieldId": "transwarp_fields",
    "techId": 55,
    "effectSummary": "All weapons targeted against an equipped ship have a 30% chance of missing completely, regardless of any other considerations.",
    "effectSummaryLen": 126
  },
  {
    "id": "sub_space_teleporter",
    "name": "Subspace Teleporter",
    "subject": "force_fields",
    "fieldId": "transwarp_fields",
    "techId": 182,
    "effectSummary": "Allows a ship to execute a hyperspace jump of up to 20 squares. The jump does not change the ship's direction; it must rotate noramlly to change facing.",
    "effectSummaryLen": 152
  },
  {
    "id": "inertia_nullifier",
    "name": "Inertial Nullifier",
    "subject": "force_fields",
    "fieldId": "transwarp_fields",
    "techId": 89,
    "effectSummary": "Creates a warp field that can operate in normal space. Increases ship mobility and makes it harder to target. Adds +100 to the ship's beam defense, and allows it to change direction without movement cost.",
    "effectSummaryLen": 204
  },
  {
    "id": "class_x_shield",
    "name": "Class X Shield",
    "subject": "force_fields",
    "fieldId": "temporal_fields",
    "techId": 37,
    "effectSummary": "Protects ships from physical and energy attacks. Absorbs up to 50 times the ship's size in damage before failing, with each attack reduced by 10 points of damage. Regenerates 30% per combat turn.",
    "effectSummaryLen": 195
  },
  {
    "id": "planetary_barrier_shield",
    "name": "Planetary Barrier Shield",
    "subject": "force_fields",
    "fieldId": "temporal_fields",
    "techId": 129,
    "effectSummary": "Seals a planet in an energy field. Converts Energized climates to Barren climates. Reduces damage against a planet by 20 points. Ground troops and morale-disruption payloads cannot pass.",
    "effectSummaryLen": 186
  },
  {
    "id": "phasing_cloak",
    "name": "Phasing Cloak",
    "subject": "force_fields",
    "fieldId": "temporal_fields",
    "techId": 128,
    "effectSummary": "Allows a ship to temporarily enter another dimension instead of just visually disappearing. While cloaked, the ship cannot be detected or attacked. Can only function for 10 turns, after which it will act like an ordinary cloaking device.",
    "effectSummaryLen": 237
  },
  {
    "id": "laser_cannon",
    "name": "Laser Cannon",
    "subject": "physics",
    "fieldId": "physics",
    "techId": 100,
    "effectSummary": "Highly focused, coherent beams of light which deliver 1-4 points of damage. Modifications: autofire, armor piercing, heavy mount, continuous, point defense, no range dissipation.",
    "effectSummaryLen": 178
  },
  {
    "id": "laser_rifle",
    "name": "Laser Rifle",
    "subject": "physics",
    "fieldId": "physics",
    "techId": 101,
    "effectSummary": "A hand-held weapon that increases the combat rating of militia, troops, and armor by +5. The bonus is not cumulative with other rifles.",
    "effectSummaryLen": 135
  },
  {
    "id": "space_scanner",
    "name": "Space Scanner",
    "subject": "physics",
    "fieldId": "physics",
    "techId": 95,
    "effectSummary": "Detects enemy ships. Base detection range is 1 parsec. Ships in transit can be detected 1 parsec further per size class of ship.",
    "effectSummaryLen": 128
  },
  {
    "id": "fusion_beam",
    "name": "Fusion Beam",
    "subject": "physics",
    "fieldId": "fusion_physics",
    "techId": 70,
    "effectSummary": "Projects a tetrium stream of charged particles, inflicting 2-6 points of damage Modifications: heavy mount, continuous, point defense, enveloping.",
    "effectSummaryLen": 146
  },
  {
    "id": "fusion_rifle",
    "name": "Fusion Rifle",
    "subject": "physics",
    "fieldId": "fusion_physics",
    "techId": null,
    "effectSummary": "A powerful hand-held rifle that increases the combat rating of militia, troops, and armor by +10. The bonus is not cumulative with other rifles.",
    "effectSummaryLen": 144
  },
  {
    "id": "tachyon_communication",
    "name": "Tachyon Communication",
    "subject": "physics",
    "fieldId": "tachyon_physics",
    "techId": null,
    "effectSummary": "Integrated into star bases, battlestations and star fortresses. Emits signals which penetrate hyperspace. Ships within 3 parsecs can recieve your orders. Increases the command points of these bases by +1.",
    "effectSummaryLen": 204
  },
  {
    "id": "tachyon_scanner",
    "name": "Tachyon Scanner",
    "subject": "physics",
    "fieldId": "tachyon_physics",
    "techId": 99,
    "effectSummary": "Detects enemy ships. Has a base detection range of 3 parsecs. Ships in transit can be detected 1 parsec further per size class of ship. Tachyon scanners reduce enemy ship's missile evasion by -20.",
    "effectSummaryLen": 196
  },
  {
    "id": "battle_scanner",
    "name": "Battle Scanner",
    "subject": "physics",
    "fieldId": "tachyon_physics",
    "techId": 24,
    "effectSummary": "Increases a ship's chance to hit with beam weapons by +50%. Adds +2 parsecs to galactic scanning range.",
    "effectSummaryLen": 103
  },
  {
    "id": "neutron_blaster",
    "name": "Neutron Blaster",
    "subject": "physics",
    "fieldId": "neutrino_physics",
    "techId": 115,
    "effectSummary": "Fires an intense high-energy beam. Inflicts 3-12 points of damage to shields. Any damage that penetrates the shields disables 1 marine unit for every 5 points of internal damage. Modifications: heavy mount, continuous.",
    "effectSummaryLen": 218
  },
  {
    "id": "neutron_scanner",
    "name": "Neutron Scanner",
    "subject": "physics",
    "fieldId": "neutrino_physics",
    "techId": 96,
    "effectSummary": "Detects enemy ships. Has a base detection range of 5 parsecs. Ships in transit can be detected at 1 parsec per size class of ship greater range. Neutron scanners reduce enemy ship's missile evasion by -40.",
    "effectSummaryLen": 205
  },
  {
    "id": "tractor_beam",
    "name": "Tractor Beam",
    "subject": "physics",
    "fieldId": "artificial_gravity",
    "techId": 188,
    "effectSummary": "It requires 1 tractor beam per size class of target ship to completely stop the target. Ships not held completely lose a portion of movement. Motionless ships can be boarded and are easy targets to hit.",
    "effectSummaryLen": 202
  },
  {
    "id": "graviton_beam",
    "name": "Graviton Beam",
    "subject": "physics",
    "fieldId": "artificial_gravity",
    "techId": 79,
    "effectSummary": "Gravitic waves that tear a target apart. Inflicts 3-15 points of damage. Any damage penetrating the ship's shields inflicts extra structural damage. Modifications: heavy mount, continuous.",
    "effectSummaryLen": 188
  },
  {
    "id": "planetary_gravity_generator",
    "name": "Planetary Gravity Generator",
    "subject": "physics",
    "fieldId": "artificial_gravity",
    "techId": 131,
    "effectSummary": "Creates artificial gravity to normalize a planet to standard gravity limits. Gravity generators eliminate the negative effects of low and high gravity fields.",
    "effectSummaryLen": 158
  },
  {
    "id": "subspace_communication",
    "name": "Subspace Communication",
    "subject": "physics",
    "fieldId": "subspace_physics",
    "techId": null,
    "effectSummary": "Allows you to issue orders to any ship within 6 squares of a star system with a starbase, battlestation, or star fortress. Increases the command points given by a base by +2 points.",
    "effectSummaryLen": 181
  },
  {
    "id": "jump_gate",
    "name": "Jump Gate",
    "subject": "physics",
    "fieldId": "subspace_physics",
    "techId": 94,
    "effectSummary": "Forms a controlled wormhole between two points, increasing the speed of ships moving through it by 3 parsecs a turn. Once discovered, all colonies will automatically be equipped with one.",
    "effectSummaryLen": 187
  },
  {
    "id": "phasors",
    "name": "Phasor",
    "subject": "physics",
    "fieldId": "multi_phased_physics",
    "techId": 127,
    "effectSummary": "Fires a trans-warp beam of phased energy that actually exists in several dimensions simultaneously, inflicting 5-20 points of damage. Modifications: autofire, continuous, heavy mount, point defense, shield piercing.",
    "effectSummaryLen": 215
  },
  {
    "id": "phasor_rifle",
    "name": "Phasor Rifle",
    "subject": "physics",
    "fieldId": "multi_phased_physics",
    "techId": null,
    "effectSummary": "A hand-held rifle that can overload an opponent's defenses with one blast, increasing the combat rating of militia, troops and armor by +20. The bonus is not cumulative with other rifles.",
    "effectSummaryLen": 187
  },
  {
    "id": "multi_phased_shields",
    "name": "Multi-Phased Shields",
    "subject": "physics",
    "fieldId": "multi_phased_physics",
    "techId": 110,
    "effectSummary": "Allow ships to rapidly change the frequency of their shields, increasing the maximum strength by +50%.",
    "effectSummaryLen": 102
  },
  {
    "id": "plasma_cannon",
    "name": "Plasma Cannon",
    "subject": "physics",
    "fieldId": "plasma_physics",
    "techId": 137,
    "effectSummary": "Fires a blast of plasma energy inflicting 6-30 poitns of damage to all 4 shields of the target. Only focuses well over a short range, doubling all range penalties. Modifications: heavy mount, and continuous fire.",
    "effectSummaryLen": 212
  },
  {
    "id": "plasma_rifle",
    "name": "Plasma Rifle",
    "subject": "physics",
    "fieldId": "plasma_physics",
    "techId": 138,
    "effectSummary": "The most powerful held weapon, increasing the combat rating of militia, troops, and armor by +30. The bonus is not cumulative with other rifle bonuses.",
    "effectSummaryLen": 151
  },
  {
    "id": "plasma_web",
    "name": "Plasma Web",
    "subject": "physics",
    "fieldId": "plasma_physics",
    "techId": 140,
    "effectSummary": "An energy web that envelopes a target within a 15 square range. Inflicts 5-25 points of damage per turn. Thsi damage persists, dissipating at a rate of 5 points per turn.",
    "effectSummaryLen": 170
  },
  {
    "id": "disruptor_cannon",
    "name": "Disruptor Cannon",
    "subject": "physics",
    "fieldId": "multi_dimensional_physics",
    "techId": 54,
    "effectSummary": "Fires intense bolts of energy that inflicts 40 points of damage. Damage from disrupter bolts is not reduced by range. Modifications: autofire, heavy mount.",
    "effectSummaryLen": 155
  },
  {
    "id": "dimensional_portal",
    "name": "Dimensional Portal",
    "subject": "physics",
    "fieldId": "multi_dimensional_physics",
    "techId": 53,
    "effectSummary": "Allows ships to cross into the dimension of the Antaran home world. To use it, select a fleet in the same system as the portal and press the 'Attack Antarans' button on the fleet pop-up.",
    "effectSummaryLen": 186
  },
  {
    "id": "hyperspace_communication",
    "name": "Hyperspace Communication",
    "subject": "physics",
    "fieldId": "hyper_dimensional_physics",
    "techId": null,
    "effectSummary": "Allows you to communicate with any ship already in hyperspace so you can change its destination. Increases the command points of star bases, battle stations and star fortresses by +3 points.",
    "effectSummaryLen": 190
  },
  {
    "id": "sensors",
    "name": "Sensors",
    "subject": "physics",
    "fieldId": "hyper_dimensional_physics",
    "techId": null,
    "effectSummary": "Detects enemy ships. Has a base detection range of 8 parsecs. Ships in transit can be detected 1 parsec further per size class of ship. Sensors reduce enemy ship's missile evasion by -70.",
    "effectSummaryLen": 187
  },
  {
    "id": "mauler_device",
    "name": "Mauler Device",
    "subject": "physics",
    "fieldId": "hyper_dimensional_physics",
    "techId": 105,
    "effectSummary": "Fires a bolt of pure energy that always hits. Inflicts 100 points of damage, but with double the range penalties for dissipation. Modifications: heavy mount.",
    "effectSummaryLen": 157
  },
  {
    "id": "time_warp_facilitator",
    "name": "Time Warp Facilitator",
    "subject": "physics",
    "fieldId": "temporal_physics",
    "techId": null,
    "effectSummary": "Allows a ship to shift in and out of the time-space continuum, enabling it to take an additional turn at the end of every combat turn.",
    "effectSummaryLen": 134
  },
  {
    "id": "starlight_projector",
    "name": "Starlight Projector",
    "subject": "physics",
    "fieldId": "temporal_physics",
    "techId": 47,
    "effectSummary": "A plasma cannon that can be mounted on a ship or planet. Automatically inflicts 400 hits to all shields of any ship, regardless of range and defense. Completely destroys a planet when used for orbital bombardment.",
    "effectSummaryLen": 213
  },
  {
    "id": "star_gate",
    "name": "Star Gate",
    "subject": "physics",
    "fieldId": "temporal_physics",
    "techId": null,
    "effectSummary": "Allows instantaneous movement between any of your colonies. All colonies are automatically equipped with one once the technology is researched.",
    "effectSummaryLen": 143
  },
  {
    "id": "nuclear_drive",
    "name": "Nuclear Drive",
    "subject": "power",
    "fieldId": "nuclear_fission",
    "techId": 120,
    "effectSummary": "Capable of moving ship 2 parsecs per turn. This is the first ship drive that makes interstellar travel possible.",
    "effectSummaryLen": 112
  },
  {
    "id": "nuclear_bomb",
    "name": "Nuclear Bomb",
    "subject": "power",
    "fieldId": "nuclear_fission",
    "techId": 119,
    "effectSummary": "A high-yield orbital bombardment device engineered to destroy ground forces and colony installations, inflicting 3-12 points of damage.",
    "effectSummaryLen": 135
  },
  {
    "id": "colony_ship",
    "name": "Colony Ship",
    "subject": "power",
    "fieldId": "cold_fusion",
    "techId": 40,
    "effectSummary": "Capable of creating a colony in a distant star system. Will not engage in combat and will be destroyed when attacked if not escorted by a military ship.",
    "effectSummaryLen": 152
  },
  {
    "id": "freighters",
    "name": "Freighters",
    "subject": "power",
    "fieldId": "cold_fusion",
    "techId": 69,
    "effectSummary": "A group of ships to transport food or colonists as needed between worlds. Each fleet contains 5 freighters. The fleet can transport 5 food units or one population unit per turn.",
    "effectSummaryLen": 177
  },
  {
    "id": "outpost_ship",
    "name": "Outpost Ship",
    "subject": "power",
    "fieldId": "cold_fusion",
    "techId": 122,
    "effectSummary": "Capable of creating an outpost on any uninhabited planet. Outposts functions like a colony, except no population units may be moved there. Outpost ships are unarmed and will be destroyed if not escorted by military ships.",
    "effectSummaryLen": 221
  },
  {
    "id": "transport",
    "name": "Transport",
    "subject": "power",
    "fieldId": "cold_fusion",
    "techId": 191,
    "effectSummary": "Troop carrier for landing marine units on a planet. They do not engage in combat and will be destroyed if not escorted by military ships. Once used, they are dismantled. Can only be build on planets with marine barracks.",
    "effectSummaryLen": 220
  },
  {
    "id": "fusion_drive",
    "name": "Fusion Drive",
    "subject": "power",
    "fieldId": "advanced_fusion",
    "techId": 72,
    "effectSummary": "Capable of faster than light travel, moving a ship 3 parsecs a turn. All ship drives are automatically upgraded when this technology is discovered.",
    "effectSummaryLen": 147
  },
  {
    "id": "fusion_bomb",
    "name": "Fusion Bomb",
    "subject": "power",
    "fieldId": "advanced_fusion",
    "techId": 71,
    "effectSummary": "A high-yield orbital bombardment device engineered to destroy ground forces and colony installations, inflicting 4-24 points of damage.",
    "effectSummaryLen": 135
  },
  {
    "id": "augmented_engines",
    "name": "Augmented Engines",
    "subject": "power",
    "fieldId": "advanced_fusion",
    "techId": null,
    "effectSummary": "Increases ship's combat speed by +5.",
    "effectSummaryLen": 36
  },
  {
    "id": "ion_drive",
    "name": "Ion Drive",
    "subject": "power",
    "fieldId": "ion_fission",
    "techId": 92,
    "effectSummary": "Capable of moving a ship 4 parsecs a turn. All ship drives are automatically upgraded when this technology is discovered.",
    "effectSummaryLen": 121
  },
  {
    "id": "ion_pulse_cannon",
    "name": "Ion Pulse Cannon",
    "subject": "power",
    "fieldId": "ion_fission",
    "techId": 97,
    "effectSummary": "fires a particle wave that overloads ships' systems and inflicts 2-10 pints of damage, bypassing all armor and structure. Completely ineffective against monsters and Antaran ships. Modifications: autofire, and continuous.",
    "effectSummaryLen": 221
  },
  {
    "id": "shield_capacitor",
    "name": "Shield Capacitor",
    "subject": "power",
    "fieldId": "ion_fission",
    "techId": 158,
    "effectSummary": "Increases the recharge rate of ship shields by +70% of their maximum strength.",
    "effectSummaryLen": 78
  },
  {
    "id": "anti_matter_drive",
    "name": "Anti-Matter Drive",
    "subject": "power",
    "fieldId": "anti_matter_fission",
    "techId": null,
    "effectSummary": "Capable of moving a ship 5 parsecs a turn. All ship drives are automatically upgraded when this technology is discovered.",
    "effectSummaryLen": 121
  },
  {
    "id": "anti_matter_torpedo",
    "name": "Anti-Matter Torpedo",
    "subject": "power",
    "fieldId": "anti_matter_fission",
    "techId": 12,
    "effectSummary": "These torpedoes are balls of antimatter that explode on contact. They travel at a speed of 20 and inflict 25 points of damage and fire every other turn. Modifications: overloaded, enveloping and ECCM.",
    "effectSummaryLen": 200
  },
  {
    "id": "anti_matter_bomb",
    "name": "Anti-Matter Bomb",
    "subject": "power",
    "fieldId": "anti_matter_fission",
    "techId": 225,
    "effectSummary": "A high-yield orbital bombardment device engineered to destroy ground forces and colony installations, inflicting 5-40 points of damage per bomb.",
    "effectSummaryLen": 144
  },
  {
    "id": "transporters",
    "name": "Transporters",
    "subject": "power",
    "fieldId": "matter_energy_conversion",
    "techId": 180,
    "effectSummary": "Allow a ship to move marines to an enemy ship at a range of 12 squares, as long as the shield facing the ship is down. Can also be used to drop bombs on planets up to 12 squares away.",
    "effectSummaryLen": 183
  },
  {
    "id": "food_replicators",
    "name": "Food Replicators",
    "subject": "power",
    "fieldId": "matter_energy_conversion",
    "techId": 64,
    "effectSummary": "Converts inert raw material into edible food. Having a facility in a colony allows you to convert 2 units of production (energy) into 1 unit of food, as needed by the colony.",
    "effectSummaryLen": 174
  },
  {
    "id": "high_energy_focus",
    "name": "High Energy Focus",
    "subject": "power",
    "fieldId": "high_energy_distribution",
    "techId": null,
    "effectSummary": "Allows a ship to channel the fire of its energy weapons more efficiently, increasing damage by +50% over base regardless of range. It does not improve the chances of hitting distant targets.",
    "effectSummaryLen": 190
  },
  {
    "id": "energy_absorber",
    "name": "Energy Absorber",
    "subject": "power",
    "fieldId": "high_energy_distribution",
    "techId": null,
    "effectSummary": "One quarter of all damage inflicted on a ship is instead stored in the energy absorber. The ship must fire this stored energy at an enemy ship in the next turn or it is lost.",
    "effectSummaryLen": 174
  },
  {
    "id": "megafluxers",
    "name": "Megafluxers",
    "subject": "power",
    "fieldId": "high_energy_distribution",
    "techId": null,
    "effectSummary": "Conduct and magnify energy transmission in less space, giving a ship more space for equipment. Increases the amount of equipment it can carry by +25%. Megafluxers are used automatically on all ships once acquired.",
    "effectSummaryLen": 213
  },
  {
    "id": "proton_torpedoes",
    "name": "Proton Torpedo",
    "subject": "power",
    "fieldId": "hyper_dimensional_fission",
    "techId": 146,
    "effectSummary": "Energy projectiles traveling at trans-warp speed, striking their target the turn they are fired. They inflict 40 points of damage. Can be fired every other turn, with a max range of 24 squares. Modifications: overloaded, enveloping, ECCM.",
    "effectSummaryLen": 238
  },
  {
    "id": "hyper_drive",
    "name": "Hyper Drive",
    "subject": "power",
    "fieldId": "hyper_dimensional_fission",
    "techId": 87,
    "effectSummary": "Capable of moving a ship 6 parsecs a turn. All ship drives are automatically upgraded when this technology is discovered.",
    "effectSummaryLen": 121
  },
  {
    "id": "hyper_x_capacitors",
    "name": "Hyper-X Capacitors",
    "subject": "power",
    "fieldId": "hyper_dimensional_fission",
    "techId": 88,
    "effectSummary": "Allows ship beam weapons to fire twice in a turn. After firing twice, one turn must be spent without firing beam weapons; otherwise the weapon can only fire once per turn.",
    "effectSummaryLen": 171
  },
  {
    "id": "interphased_drive",
    "name": "Interphased Drive",
    "subject": "power",
    "fieldId": "interphased_fission",
    "techId": null,
    "effectSummary": "Capable of moving a ship 7 parsecs a turn. All ship drives are automatically upgraded when this technology is discovered.",
    "effectSummaryLen": 121
  },
  {
    "id": "plasma_torpedoes",
    "name": "Plasma Torpedo",
    "subject": "power",
    "fieldId": "interphased_fission",
    "techId": 139,
    "effectSummary": "Plasma warhead capable of 120 points of damage. Travels with a combat speed of 24, losing 5 points of strength for each square traveled and firing every other turn. Modifications: overloaded, enveloping, ECCM, no range dissipation.",
    "effectSummaryLen": 231
  },
  {
    "id": "neutronium_bomb",
    "name": "Neutronium Bomb",
    "subject": "power",
    "fieldId": "interphased_fission",
    "techId": 118,
    "effectSummary": "A high-yield orbital bombardment device engineered to destroy ground forces and colony installations, inflicting 10-60 points of damage.",
    "effectSummaryLen": 136
  },
  {
    "id": "space_academy",
    "name": "Space Academy",
    "subject": "sociology",
    "fieldId": "military_tactics",
    "techId": 164,
    "effectSummary": "Trains ship crews, adding 1 to their starting level. Ships stationed in the system gain 2 experience each turn.",
    "effectSummaryLen": 111
  },
  {
    "id": "xeno_psychology",
    "name": "Xeno Psychology",
    "subject": "sociology",
    "fieldId": "xeno_relations",
    "techId": null,
    "effectSummary": "Focuses on the motivation of other races in an attempt to form deals that are more appealing. The effect is to permanently add +30 diplomatic points to every deal offered to your opponents.",
    "effectSummaryLen": 189
  },
  {
    "id": "alien_management_center",
    "name": "Alien Control Center",
    "subject": "sociology",
    "fieldId": "xeno_relations",
    "techId": 8,
    "effectSummary": "Provides better control of occupied alien populations: aliens work harder, assimilate into your empire twice as fast, and are half as likely to revolt.",
    "effectSummaryLen": 151
  },
  {
    "id": "stock_exchange",
    "name": "Planetary Stock-Exchange",
    "subject": "sociology",
    "fieldId": "macro_economics",
    "techId": 173,
    "effectSummary": "Increases the revenues earned on a planet by +100%.",
    "effectSummaryLen": 51
  },
  {
    "id": "astro_university",
    "name": "Astro University",
    "subject": "sociology",
    "fieldId": "teaching_methods",
    "techId": 18,
    "effectSummary": "Using the most advanced teaching methods available, the efficiency of farmers, workers, and scientists is increased. Each receives a +1 bonus.",
    "effectSummaryLen": 142
  },
  {
    "id": "confederation",
    "name": "Confederation",
    "subject": "sociology",
    "fieldId": "advanced_governments",
    "techId": null,
    "effectSummary": "Advanced form of feudalism. Warships cost only one-third of normal production and the feudal research penalty is halved to -25%.",
    "effectSummaryLen": 128
  },
  {
    "id": "imperium",
    "name": "Imperium",
    "subject": "sociology",
    "fieldId": "advanced_governments",
    "techId": null,
    "effectSummary": "Advanced form of dictatorship. Total command points generated are increased by +50% and all defensive spy rolls are at +20.",
    "effectSummaryLen": 123
  },
  {
    "id": "federation",
    "name": "Federation",
    "subject": "sociology",
    "fieldId": "advanced_governments",
    "techId": null,
    "effectSummary": "Advanced form of democracy. The +50% income and research bonuses rise to +75%.",
    "effectSummaryLen": 78
  },
  {
    "id": "galactic_unification",
    "name": "Galactic Unification",
    "subject": "sociology",
    "fieldId": "advanced_governments",
    "techId": null,
    "effectSummary": "Advanced form of unification. The +50% food and industry bonuses rise to +100%.",
    "effectSummaryLen": 79
  },
  {
    "id": "galactic_currency_exchange",
    "name": "Galactic Currency Exchange",
    "subject": "sociology",
    "fieldId": "galactic_economics",
    "techId": 73,
    "effectSummary": "Eliminates the need for hard currency, replacing it with instantaneous electronic exchanges. Increases the money generated by all colonies by +50%.",
    "effectSummaryLen": 147
  }
] as const;

export const STARTING_FIELD_NUMS: Readonly<Record<string, readonly number[]>> = {
  "pre_warp": [
    29,
    28,
    55,
    57,
    22
  ],
  "average": [
    4,
    56,
    23,
    31,
    9,
    10,
    18,
    7
  ]
} as const;

export const PICK_BUDGET: Readonly<Record<string, number>> = {
  "maximum_positive_custom_race_picks": 10,
  "maximum_negative_picks": -10,
  "adaptive_upgrade_added_picks": 4
} as const;

export const CP_SOURCES: Readonly<Record<string, number>> = {
  "colony": 1,
  "star_base": 2,
  "battlestation": 4,
  "star_fortress": 6,
  "warlord_pick_bonus": 2,
  "tachyon_communications_bonus": 1
} as const;

export const CP_USAGE: Readonly<Record<string, number>> = {
  "frigate": 1,
  "destroyer": 1,
  "cruiser": 2,
  "battleship": 4,
  "titan": 6,
  "doomstar": 12
} as const;

export const SCAN_BONUSES: Readonly<Record<string, number>> = {
  "normal_scanner": 2,
  "neutron_scanner": 5,
  "tachyon_scanner": 7,
  "scout_lab": 2,
  "sensor_cluster": 2
} as const;

export const STEALTH_BONUSES: Readonly<Record<string, number>> = {
  "stealth_armor": 10,
  "sub_space_teleporter": 10,
  "phasing_cloak": 10,
  "stealthy_ships_race_pick": 10
} as const;

export const LANDER_COSTS: Readonly<Record<string, number>> = {
  "colonization_lander": 100,
  "outpost_lander": 100,
  "frigate_hull_in_colony_queue": 20,
  "destroyer_hull_in_colony_queue": 70,
  "cruiser_hull_in_colony_queue": 250,
  "battleship_hull_in_colony_queue": 600,
  "titan_hull_in_colony_queue": 1500,
  "doomstar_hull_in_colony_queue": 4000
} as const;

export const MISC_COSTS: Readonly<Record<string, number>> = {
  "freighter": 100,
  "spy": 50,
  "housing": 0,
  "trade_goods": 50
} as const;

